<template>
    <div>
        <div style="width:100%;min-height:150vh">
            <div class="container">
                <div class="row  mt-4">
                    <div class="col-6 text-teal">
                        {{savingText}}
                    </div>
                    <div class="text-right col-6">
                        <button class="btn btn-outline-primary rounded-full mr-2" @click="saveQuotePricing('manualSave')">
                            Save
                        </button>
                    </div>
                    <div class="col-6">
                        <b-form-checkbox
                            :id="'defaultFont'"
                            v-model="defaultFont"
                            :name="'defaultFont'"
                            value="true"
                            unchecked-value="false"
                            class="m-0 p-0 pl-1"
                            @change="saveQuotePricing()"
                        >
                            Reset template to default format settings
                        </b-form-checkbox>
                    </div>
                </div>
                <div class="row p-0 m-0 text-xl font-weight-bold mt-3 py-2" style="background-color: #ebebeb;">
                    <div class="col-6 m-0 p-0 text-left pl-3">
                        Quote
                    </div>
                    <div class="col-6 m-0 p-0 text-right pr-3">
                        Amount: ${{ (total)? total:0 }}
                    </div>
                </div>
                <div class="row p-0 m-0 mt-2">
                    <div class="col-6 m-0 p-0 text-left">
                        <div class="w-75 pgQuoteProjectDiv" @click="setFocusedEditor('PGQuoteProject')">
                            <ckeditor-container
                                editorKey="pgQuoteProject"
                                placeholder=""
                                id="projectData"
                                v-model="projectData"
                                :options="[]"
                                @mention="addMention"
                                mentionFrom="name"
                                @input="saveQuotePricing()"
                                @focus="setFocusedEditor"
                                @focusout="unsetFocusedEditor"
                                ref="PGQuoteProject"
                            ></ckeditor-container>
                        </div>
                        <!-- <label class="font-weight-bold text-sm">Project:</label>
                        {{ proposal.project_name }}<br>
                        <label class="text-sm">Project Address Line 1</label>
                        <input type="text" class="form-control form-control-sm w-50 mb-2 border-grey-light shadow-none" placeholder="Project Address Line 1" v-model="projectInfo.address1" @input="saveQuotePricing()">
                        <label class="text-sm">Project Address Line 2</label>
                        <input type="text" class="form-control form-control-sm w-50 border-grey-light shadow-none" placeholder="Project Address Line 2" v-model="projectInfo.address2" @input="saveQuotePricing()"> -->
                    </div>
                    <div class="col-6 m-0 p-0 text-right">
                        <div v-if="templateImageData">
                            <div :style="'background-image:url('+templateImageData+');background-size:contain;width: 250px;height:250px;float:right'"></div>
                        </div>
                        <!-- <label class="font-weight-bold text-sm w-full">Prepared for:</label><br>
                        <span class="w-100 float-right">
                            <label class="text-sm">Company Name</label><br>
                            <input type="text" class="form-control form-control-sm w-50 float-right border-grey-light shadow-none" placeholder="Company Name" v-model="companyInfo.name" @input="saveQuotePricing()">
                        </span>
                        <span class="w-100 float-right">
                            <label class="text-sm">Sales Rep Name</label><br>
                            <input type="text" class="form-control form-control-sm w-50 float-right border-grey-light shadow-none" placeholder="Sales Rep Name" v-model="companyInfo.salesRepName" @input="saveQuotePricing()">
                        </span>
                        <span class="w-100 float-right">
                            <label class="text-sm">Company Phone</label><br>
                            <input type="text" class="form-control form-control-sm w-50 float-right border-grey-light shadow-none" placeholder="Company Number" v-model="companyInfo.phone" maxlength="64"
                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']" @input="saveQuotePricing()">
                        </span>
                        <span class="w-100 float-right">
                            <label class="text-sm">Company Email</label><br>
                            <input type="email" class="form-control form-control-sm w-50 float-right border-grey-light shadow-none" placeholder="Company Email" v-model="companyInfo.email" @input="saveQuotePricing()">
                        </span>
                        <span class="w-100 float-right">
                            <label class="text-sm">Company Address</label><br>
                            <input type="text" class="form-control form-control-sm w-50 float-right border-grey-light shadow-none" placeholder="Company Address" v-model="companyInfo.address" @input="saveQuotePricing()">
                        </span> -->
                    </div>
                </div>


                <div class="row p-0 m-0 mt-2">
                    <div class="col-6 m-0 p-0 text-left">
                        <div class="w-75 pgQuoteCompany" @click="setFocusedEditor('PGQuoteCompany')">
                            <ckeditor-container
                                editorKey="pgQuoteCompany"
                                placeholder=""
                                id="comment"
                                v-model="companyData"
                                :options="[]"
                                @mention="addMention"
                                mentionFrom="name"
                                @input="saveQuotePricing()"
                                @focus="setFocusedEditor"
                                @focusout="unsetFocusedEditor"
                                ref="PGQuoteCompany"
                            ></ckeditor-container>
                        </div>
                        <!-- <label class="font-weight-bold text-sm">Contact</label>
                        <multiselect v-model="selectedContact"
                                     tag-placeholder="Press enter to add"
                                     placeholder="Select Contact"
                                     label="name" track-by="id"
                                     :options="allContacts"
                                     :multiple="false"
                                     :taggable="true"
                                     :close-on-select="true"
                                     class="w-50"
                                     @select="selectContactAddress(selectedContact)"
                                     @remove="removeContactAddress()"
                                     :show-labels="false"
                        >
                        </multiselect> -->
                    </div>
                    <div class="col-6 m-0 p-0 text-right">
                        <div class="w-75 pgQuoteCompany float-right" @click="setFocusedEditor('PGQuoteSales')">
                            <ckeditor-container
                                editorKey="pgQuoteSales"
                                placeholder=""
                                id="salesRepData"
                                v-model="salesRepData"
                                :options="[]"
                                @mention="addMention"
                                mentionFrom="name"
                                @input="saveQuotePricing()"
                                @focus="setFocusedEditor"
                                @focusout="unsetFocusedEditor"
                                ref="PGQuoteSales"
                            ></ckeditor-container>
                        </div>
                    </div>
                </div>
                <!-- <div class="row p-0 m-0 mt-2">
                    <div class="col-3 m-0 p-0 text-left pr-4">
                        <label class="font-weight-bold text-sm">Billing Address</label>
                        <b-form-textarea
                            id="textarea-large"
                            size="lg"
                            class="text-sm"
                            placeholder="Billing Address"
                            v-model="billingAddress"
                            rows="4"
                            @input="saveQuotePricing()"
                        ></b-form-textarea>
                    </div>
                    <div class="col-3 m-0 p-0 text-left pl-4">
                        <label class="font-weight-bold text-sm">Shipping Address</label>
                        <b-form-textarea
                            id="textarea-large"
                            size="lg"
                            class="text-sm"
                            placeholder="Shipping Address"
                            v-model="shippingAddress"
                            rows="4"
                            @input="saveQuotePricing()"
                        ></b-form-textarea>
                    </div>
                    <div class="col-6 m-0 p-0 text-right">
                        <label class="font-weight-bold text-sm w-full">Quote Date</label>
                        <datetime type="date"
                                  v-model="quoteDate"
                                  :use-utc="true"
                                  class="w-25 float-right"
                                  :week-start="7"
                                  :format="proposal.masks.date_mask"
                                  :max-datetime="(quoteExpirationDate)? quoteExpirationDate:''"
                                  input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 text-right"
                                  @input="saveQuotePricing()"
                        >
                        </datetime>
                        <label class="font-weight-bold text-sm w-full">Expiration Date</label>
                        <datetime type="date"
                                  v-model="quoteExpirationDate"
                                  :use-utc="true"
                                  class="w-25 float-right"
                                  :week-start="7"
                                  :format="proposal.masks.date_mask"
                                  :min-datetime="(quoteDate)? quoteDate:''"
                                  input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 text-right"
                                  @input="saveQuotePricing()"
                        >
                        </datetime>
                    </div>
                </div> -->

                <div class="w-full mt-4 mb-4 border-1">
                    <div class="w-full d-inline-flex align-items-stretch bg-teal-lightest">
                        <div style="width: 3%; color: transparent;" class="px-1 border-r-1 d-flex align-items-center">
                            #
                        </div>
                        <div style="width: 3%" class="px-1 border-r-1 d-flex align-items-center">
                            #
                        </div>
                        <div style="width: 17%" class="px-1 border-r-1 d-flex align-items-center">
                            <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="sectionConfig.product.title">
                        </div>
                        <div style="width: 35%" class="px-1 border-r-1 d-flex align-items-center">
                            <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="sectionConfig.description.title">
                        </div>
                        <div style="width: 15%" class="px-1 border-r-1 d-flex align-items-center">
                            <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="sectionConfig.specs.title">
                        </div>
                        <div style="width: 7%" class="px-1 border-r-1 d-flex align-items-center">
                            <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="sectionConfig.qty.title">
                        </div>
                        <div style="width: 7%" class="px-1 border-r-1 d-flex align-items-center">
                            <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="sectionConfig.rate.title">
                        </div>
                        <div style="width: 7%" class="px-1 border-r-1 d-flex align-items-center">
                            <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="sectionConfig.amount.title">
                        </div>
                        <div style="width: 3%" class="px-1 border-r-1 d-flex align-items-center">
                            <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="sectionConfig.tax.title">
                        </div>
                        <div style="width: 3%" class="px-1 d-flex align-items-center">
                            <i class="fa fa-fw text-left fa-btn fa-cog pointer" :id="'sectionConfig'" tabindex="0" title="Configure Section"></i>
                            <b-popover ref="mainSectionConfigPopover" :target="'sectionConfig'" title="Show/Hide Fields" :custom-class="'additionalPopOverClass'">
                                <div>
                                    <b-form-checkbox
                                        :id="'sectionConfig-product'"
                                        v-model="sectionConfig.product.show"
                                        :name="'sectionConfig-product'"
                                        value="true"
                                        unchecked-value="false"
                                        @change="saveQuotePricing()"
                                    >
                                        {{sectionConfig.product.title}}
                                    </b-form-checkbox>
                                </div>
                                <div>
                                    <b-form-checkbox
                                        :id="'sectionConfig-description'"
                                        v-model="sectionConfig.description.show"
                                        :name="'sectionConfig-description'"
                                        value="true"
                                        unchecked-value="false"
                                        @change="saveQuotePricing()"
                                    >
                                        {{sectionConfig.description.title}}
                                    </b-form-checkbox>
                                </div>
                                <div>
                                    <b-form-checkbox
                                        :id="'sectionConfig-specs'"
                                        v-model="sectionConfig.specs.show"
                                        :name="'sectionConfig-specs'"
                                        value="true"
                                        unchecked-value="false"
                                        @change="saveQuotePricing()"
                                    >
                                        {{sectionConfig.specs.title}}
                                    </b-form-checkbox>
                                </div>
                                <div>
                                    <b-form-checkbox
                                        :id="'sectionConfig-qty'"
                                        v-model="sectionConfig.qty.show"
                                        :name="'sectionConfig-qty'"
                                        value="true"
                                        unchecked-value="false"
                                        @change="saveQuotePricing()"
                                    >
                                        {{sectionConfig.qty.title}}
                                    </b-form-checkbox>
                                </div>
                                <div>
                                    <b-form-checkbox
                                        :id="'sectionConfig-rate'"
                                        v-model="sectionConfig.rate.show"
                                        :name="'sectionConfig-rate'"
                                        value="true"
                                        unchecked-value="false"
                                        @change="saveQuotePricing()"
                                    >
                                        {{sectionConfig.rate.title}}
                                    </b-form-checkbox>
                                </div>
                                <div>
                                    <b-form-checkbox
                                        :id="'sectionConfig-amount'"
                                        v-model="sectionConfig.amount.show"
                                        :name="'sectionConfig-amount'"
                                        value="true"
                                        unchecked-value="false"
                                        @change="saveQuotePricing()"
                                    >
                                        {{sectionConfig.amount.title}}
                                    </b-form-checkbox>
                                </div>
                            </b-popover>
                        </div>
                    </div>
                    <draggable v-model="quotePricingData" v-if="quotePricingData.length > 0" @change="saveQuotePricing()">
                        <transition-group>
                            <div v-for="(productData, index) in quotePricingData" :key="productData.key">
                                <div class="w-full d-inline-flex text-xs border-t-1 align-items-stretch">
                                    <div style="width: 3%; color: transparent;" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                        <img style="cursor: grab;width: 100%;height: auto;margin: 0 auto;max-width: 22px;" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/drag-icon.png">
                                    </div>
                                    <div style="width: 3%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                        {{index+1}}
                                    </div>
                                    <div style="width: 17%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="!productData.product">
                            <multiselect
                                v-model="productData.product"
                                tag-placeholder="Press enter to add"
                                placeholder="Product or Bundle"
                                label="name" track-by="id"
                                :options="allQuoteProductsAndBundles"
                                :multiple="false"
                                :taggable="true"
                                :close-on-select="true"
                                class="w-100 scalingInput"
                                @select="selectProduct(index, productData.product)"
                                group-values="item_options"
                                group-label="item_type"
                                :group-select="false"
                                :show-labels="false"
                            >
                            </multiselect>
                        </span>
                                        <span v-else>
                            <p class="font-weight-bold" v-if="productData.product.category  && productData.product.type === 'product'">{{productData.product.category.full_category_path}}</p>
                            <p :class="(productData.product.type === 'product')? 'font-weight-normal':'font-weight-bold'">{{productData.product.name}}</p>
                        </span>
                                    </div>
                                    <div style="width: 35%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="productData.product" class="w-100">
                            <p class="font-weight-normal w-100">
                                <b-form-textarea
                                    :id="index+'-product-description'"
                                    size="sm"
                                    class="text-xs border-1 shadow-none border-grey-light"
                                    style="width: 100% !important"
                                    placeholder="Description"
                                    v-model="productData.product.description"
                                    rows="4"
                                    @input="saveQuotePricing()"
                                ></b-form-textarea>
                            </p>
                        </span>
                                    </div>
                                    <div style="width: 15%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                        <div v-if="productData.product" class="w-100">
                                            <div  class="w-100" v-if="productData.product.type === 'product' && productData.product.custom_fields.length > 0">
                                                <div  class="w-100" v-for="(customField, fieldIndex) in productData.product.custom_fields">
                                                    <div  class="w-100 my-2" v-if="customField.type === 1">
                                                        <p class="font-weight-bold">{{customField.name}}</p>
                                                        <multiselect
                                                            v-model="customField.selected_value"
                                                            placeholder="Please Select"
                                                            label="name" track-by="id"
                                                            :options="customField.custom_field_options"
                                                            :multiple="false"
                                                            :taggable="false"
                                                            :searchable="false"
                                                            :close-on-select="true"
                                                            class="w-100"
                                                            @select="singleSelectAmountCalculate(index, fieldIndex, customField.selected_value)"
                                                            @remove="(option) => singleSelectUnselectAmountCalculate(option, index, fieldIndex)"
                                                            :show-labels="false"
                                                        >
                                                        </multiselect>
                                                    </div>
                                                    <div  class="w-100 my-2" v-if="customField.type === 2">
                                                        <p class="font-weight-bold">{{customField.name}}</p>
                                                        <multiselect
                                                            v-model="customField.selected_value"
                                                            placeholder="Please Select"
                                                            label="name" track-by="id"
                                                            :options="customField.custom_field_options"
                                                            :multiple="true"
                                                            :taggable="true"
                                                            :searchable="false"
                                                            :close-on-select="true"
                                                            class="w-100"
                                                            @select="multiSelectAmountCalculate(index, fieldIndex, customField.selected_value)"
                                                            @remove="(option) => multiSelectUnselectAmountCalculate(option, index, fieldIndex)"
                                                            :show-labels="false"
                                                        >
                                                        </multiselect>
                                                    </div>
                                                    <div  class="w-100 my-2" v-if="customField.type === 3">
                                                        <p class="font-weight-bold">{{customField.name}}</p>
                                                        <b-form-group >
                                                            <b-form-radio @change="radioButtonCalculate(index, fieldIndex, customField.selected_value)" :key="'custom-radio-button-'+option.id" v-for="option in customField.custom_field_options" v-model="customField.selected_value" :name="'product-'+option.name" :value="option">{{option.name}}</b-form-radio>
                                                        </b-form-group>
                                                    </div>
                                                    <div  class="w-100 my-2" v-if="customField.type === 5">
                                                        <p><b>{{customField.name}}</b> {{customField.custom_field_options[0].name}}</p>
                                                        <b-form-textarea
                                                            :id="fieldIndex+'-product-text-field-description'"
                                                            size="sm"
                                                            class="text-xs border-1 shadow-none border-grey-light"
                                                            style="width: 100% !important"
                                                            v-model="customField.selected_value"
                                                            rows="2"
                                                            @input="saveQuotePricing()"
                                                        ></b-form-textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="productData.product" class="w-100">
                            <input v-if="productData.product.type === 'product'" @input="calculateAmount(index, productData.quantity, productData.product)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="productData.quantity">
                            <input v-else @input="calculateBundleProducts(index, productData.quantity, productData.product)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="productData.quantity">
                        </span>
                                    </div>
                                    <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                        <p class="font-weight-normal w-100" v-if="productData.product">
                                            <input @input="calculateAmount(index, productData.product.sales_price, productData.product)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="productData.product.sales_price" v-if="productData.product.type === 'product'">
                                        </p>
                                    </div>
                                    <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="productData.product" class="w-100">
                            <p class="font-weight-normal w-100" v-if="productData.amount">
                                <input @input="calculateRateFromAmount(index, productData.amount, productData.product)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="productData.amount" v-if="productData.product.type === 'product'">
                            </p>
                        </span>
                                    </div>
                                    <div style="width: 3%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                        <b-form-checkbox
                                            :id="'checkbox-'+productData.key"
                                            v-model="productData.tax"
                                            :name="'checkbox-'+productData.key"
                                            value="taxable"
                                            unchecked-value="non-taxable"
                                            v-if="productData.product && productData.product.type === 'product'"
                                            @change="calculateTotal()"
                                            class="p-0 px-2"
                                        >
                                        </b-form-checkbox>
                                        <b-form-checkbox
                                            :id="'checkbox-'+productData.key"
                                            v-model="productData.tax"
                                            :name="'checkbox-'+productData.key"
                                            value="taxable"
                                            unchecked-value="non-taxable"
                                            v-else-if="productData.product && productData.product.type === 'bundle'"
                                            @change="checkTaxForBundle(index)"
                                            class="p-0 px-2"
                                        >
                                        </b-form-checkbox>
                                    </div>
                                    <div style="width: 3%" class="px-1 py-2 d-flex align-items-center">
                                        <i @click="deleteProduct(index)" class="fa fa-trash text-danger w-full text-center text-lg cursor-pointer" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="w-full d-inline-flex text-xs border-t-1 align-items-stretch" v-if="productData.product && productData.product.type === 'bundle'" v-for="(bundle, bundleIndex) in (productData.product)? productData.product.bundle_product_and_services:[]">
                                    <div style="width: 3%; color: transparent;" class="px-1 border-r-1 py-2 d-flex align-items-center">

                                    </div>
                                    <div style="width: 3%" class="px-1 border-r-1 py-2 d-flex align-items-center">

                                    </div>
                                    <div style="width: 17%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span>
                            <p class="font-weight-bold" v-if="bundle.pg_product_and_service.category">{{bundle.pg_product_and_service.category.full_category_path}}</p>
                            <p class="font-weight-normal">{{bundle.pg_product_and_service.name}}</p>
                        </span>
                                    </div>
                                    <div style="width: 35%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="bundle" class="w-100">
                            <p class="font-weight-normal w-100">
                                <b-form-textarea
                                    :id="index+'-bundle-product-description-'+bundleIndex"
                                    size="sm"
                                    class="text-xs border-1 shadow-none border-grey-light"
                                    placeholder="Description"
                                    v-model="bundle.pg_product_and_service.description"
                                    rows="4"
                                    style="width: 100% !important"
                                    @input="saveQuotePricing()"
                                ></b-form-textarea>
                            </p>
                        </span>
                                    </div>
                                    <div style="width: 15%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="bundle">
                            <div  class="w-100" v-if="bundle.pg_product_and_service.custom_fields.length > 0">
                                <div  class="w-100" v-for="(customField, fieldIndex) in bundle.pg_product_and_service.custom_fields">
                                    <div  class="w-100 my-2" v-if="customField.type === 1">
                                        <p class="font-weight-bold">{{customField.name}}</p>
                                        <multiselect
                                            v-model="customField.selected_value"
                                            placeholder="Please Select"
                                            label="name" track-by="id"
                                            :options="customField.custom_field_options"
                                            :multiple="false"
                                            :taggable="false"
                                            :searchable="false"
                                            :close-on-select="true"
                                            class="w-100"
                                            @select="bundleSingleSelectAmountCalculate(index, bundleIndex, fieldIndex, customField.selected_value)"
                                            @remove="(option) => bundleSingleSelectUnselectAmountCalculate(option, bundleIndex, index, fieldIndex)"
                                            :show-labels="false"
                                        >
                                        </multiselect>
                                    </div>
                                    <div  class="w-100 my-2" v-if="customField.type === 2">
                                        <p class="font-weight-bold">{{customField.name}}</p>
                                        <multiselect
                                            v-model="customField.selected_value"
                                            placeholder="Please Select"
                                            label="name" track-by="id"
                                            :options="customField.custom_field_options"
                                            :multiple="true"
                                            :taggable="true"
                                            :searchable="false"
                                            :close-on-select="true"
                                            class="w-100"
                                            @select="bundleMultiSelectAmountCalculate(index, bundleIndex, fieldIndex, customField.selected_value)"
                                            @remove="(option) => bundleMultiSelectUnselectAmountCalculate(option, bundleIndex, index, fieldIndex)"
                                            :show-labels="false"
                                        >
                                        </multiselect>
                                    </div>
                                    <div  class="w-100 my-2" v-if="customField.type === 3">
                                        <p class="font-weight-bold">{{customField.name}}</p>
                                        <b-form-group >
                                            <b-form-radio @change="bundleRadioButtonCalculate(index, bundleIndex, fieldIndex, customField.selected_value)" :key="'bundle-custom-radio-button-'+option.id" v-for="option in customField.custom_field_options" v-model="customField.selected_value" :name="'bundle-'+option.name" :value="option">{{option.name}}</b-form-radio>
                                        </b-form-group>
                                    </div>
                                    <div  class="w-100 my-2" v-if="customField.type === 5">
                                        <p><b>{{customField.name}}</b> {{customField.custom_field_options[0].name}}</p>
                                        <b-form-textarea
                                            :id="fieldIndex+'-bundle-product-text-field-description'"
                                            size="sm"
                                            class="text-xs border-1 shadow-none border-grey-light"
                                            style="width: 100% !important"
                                            v-model="customField.selected_value"
                                            rows="2"
                                            @input="saveQuotePricing()"
                                        ></b-form-textarea>
                                    </div>
                                </div>
                            </div>
                        </span>
                                    </div>
                                    <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="bundle" class="w-100">
                            <input @input="calculateBundleAmount(index, bundleIndex, bundle.quantity, bundle.pg_product_and_service)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="bundle.quantity">
                        </span>
                                    </div>
                                    <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                        <p class="font-weight-normal w-100" v-if="bundle">
                                            <input @input="calculateBundleAmount(index, bundleIndex, bundle.pg_product_and_service.sales_price, bundle.pg_product_and_service)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="bundle.pg_product_and_service.sales_price">
                                        </p>
                                    </div>
                                    <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="bundle" class="w-100">
                            <p class="font-weight-normal w-100" v-if="bundle.amount">
                                <input @input="calculateBundleRateFromAmount(index, bundleIndex, bundle.amount, bundle.pg_product_and_service)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="bundle.amount">
                            </p>
                        </span>
                                    </div>
                                    <div style="width: 3%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                        <b-form-checkbox
                                            :id="'checkboxBundle-'+bundleIndex+'-'+productData.key"
                                            v-model="bundle.pg_product_and_service.sales_tax"
                                            :name="'checkboxBundle-'+bundleIndex+'-'+productData.key"
                                            value="taxable"
                                            unchecked-value="non-taxable"
                                            v-if="bundle"
                                            @change="calculateTotal();uncheckBundleTax(index)"
                                            class="p-0 px-2"
                                        >
                                        </b-form-checkbox>
                                    </div>
                                    <div style="width: 3%" class="px-1 py-2 d-flex align-items-center">

                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </draggable>
                    <div class="w-full d-inline-flex text-xs border-t-1 align-items-stretch justify-content-between" v-if="quotePricingDataSubTotal">
                        <div style="width: 90%;" class="px-1 border-r-1 py-2 d-flex align-items-center font-weight-bold text-lg justify-content-end text-right">
                            Bid Total:
                        </div>
                        <div style="width: 10%;" class="px-1 py-2 d-flex align-items-center font-weight-bold text-xl ">
                            ${{quotePricingDataSubTotal}}
                        </div>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-6">
                        <button class="btn btn-outline-primary  text-sm px-4 py-2 font-weight-normal" @click="addSection()" v-if="additionalQuotePricingData.length == 0">
                            Add Section
                        </button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-outline-primary float-right text-sm px-4 py-2 font-weight-normal" @click="addRow()">
                            Add Row
                        </button>
                    </div>
                </div>

                <!--      Additional Pricing Item          -->


                <div class="w-full p-0 m-0 mt-3 mb-3" v-for="(additionalData, additionalIndex) in additionalQuotePricingData">
                    <div class="w-full">
                        <input type="text" @input="saveQuotePricing()" class="form-control border-0 shadow-none" v-model="additionalData.sectionTitle">
                    </div>

                    <div class="w-full mt-4 mb-4 border-1">
                        <div class="w-full d-inline-flex align-items-stretch bg-teal-lightest">
                            <div style="width: 3%; color: transparent;" class="px-1 border-r-1 d-flex align-items-center">
                                #
                            </div>
                            <div style="width: 3%" class="px-1 border-r-1 d-flex align-items-center">
                                #
                            </div>
                            <div style="width: 17%" class="px-1 border-r-1 d-flex align-items-center">
                                <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="additionalData.product.title">
                            </div>
                            <div style="width: 34%" class="px-1 border-r-1 d-flex align-items-center">
                                <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="additionalData.description.title">
                            </div>
                            <div style="width: 15%" class="px-1 border-r-1 d-flex align-items-center">
                                <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="additionalData.specs.title">
                            </div>
                            <div style="width: 7%" class="px-1 border-r-1 d-flex align-items-center">
                                <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="additionalData.qty.title">
                            </div>
                            <div style="width: 7%" class="px-1 border-r-1 d-flex align-items-center">
                                <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="additionalData.rate.title">
                            </div>
                            <div style="width: 7%" class="px-1 border-r-1 d-flex align-items-center">
                                <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="additionalData.amount.title">
                            </div>
                            <div style="width: 3%" class="px-1 border-r-1 d-flex align-items-center">
                                <input @input="saveQuotePricing()" type="text" class="form-control text-xs p-0 border-0 bg-transparent text-black shadow-none custom-title-height" v-model="additionalData.tax.title">
                            </div>
                            <div style="width: 4%" class="px-1 d-flex align-items-center justify-content-between">
                                <i @click="removeSection(additionalIndex)" class="fa fa-trash text-danger  cursor-pointer" aria-hidden="true" title="Delete Section"></i>
                                <i class="fa fa-fw text-left fa-btn fa-cog pointer" :id="'additional-'+additionalIndex" tabindex="0" title="Configure Section"></i>
                                <b-popover ref="sectionConfigPopover" :target="'additional-'+additionalIndex" title="Section Setting" :custom-class="'additionalPopOverClass'">
                                    <div>
                                        <b-form-checkbox
                                            :id="'additional-section-sum-to-total-'+additionalIndex"
                                            v-model="additionalData.sumToTotal"
                                            :name="'additional-section-sum-to-total-'+additionalIndex"
                                            value="true"
                                            unchecked-value="false"
                                            @change="calculateTotal()"
                                        >
                                            Add sum to total
                                        </b-form-checkbox>
                                    </div>
                                    <p class="bg-grey-light p-2 mt-2 rounded row">Show/Hide Fields</p>
                                    <div>
                                        <b-form-checkbox
                                            :id="'additional-product-'+additionalIndex"
                                            v-model="additionalData.product.show"
                                            :name="'additional-product-'+additionalIndex"
                                            value="true"
                                            unchecked-value="false"
                                            @change="saveQuotePricing()"
                                        >
                                            {{additionalData.product.title}}
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox
                                            :id="'additional-description-'+additionalIndex"
                                            v-model="additionalData.description.show"
                                            :name="'additional-description-'+additionalIndex"
                                            value="true"
                                            unchecked-value="false"
                                            @change="saveQuotePricing()"
                                        >
                                            {{additionalData.description.title}}
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox
                                            :id="'additional-specs-'+additionalIndex"
                                            v-model="additionalData.specs.show"
                                            :name="'additional-specs-'+additionalIndex"
                                            value="true"
                                            unchecked-value="false"
                                            @change="saveQuotePricing()"
                                        >
                                            {{additionalData.specs.title}}
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox
                                            :id="'additional-qty-'+additionalIndex"
                                            v-model="additionalData.qty.show"
                                            :name="'additional-qty-'+additionalIndex"
                                            value="true"
                                            unchecked-value="false"
                                            @change="saveQuotePricing()"
                                        >
                                            {{additionalData.qty.title}}
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox
                                            :id="'additional-rate-'+additionalIndex"
                                            v-model="additionalData.rate.show"
                                            :name="'additional-rate-'+additionalIndex"
                                            value="true"
                                            unchecked-value="false"
                                            @change="saveQuotePricing()"
                                        >
                                            {{additionalData.rate.title}}
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox
                                            :id="'additional-amount-'+additionalIndex"
                                            v-model="additionalData.amount.show"
                                            :name="'additional-amount-'+additionalIndex"
                                            value="true"
                                            unchecked-value="false"
                                            @change="saveQuotePricing()"
                                        >
                                            {{additionalData.amount.title}}
                                        </b-form-checkbox>
                                    </div>
                                </b-popover>
                            </div>
                        </div>
                        <draggable v-model="additionalData.data" v-if="additionalData.data.length > 0" @change="saveQuotePricing()">
                            <transition-group>
                                <div v-for="(productData, index) in additionalData.data" :key="additionalIndex+'-'+productData.key">
                                    <div class="w-full d-inline-flex text-xs border-t-1 align-items-stretch">
                                        <div style="width: 3%; color: transparent;" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                            <img style="cursor: grab;width: 100%;height: auto;margin: 0 auto;max-width: 22px;" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/drag-icon.png">
                                        </div>
                                        <div style="width: 3%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                            {{index+1}}
                                        </div>
                                        <div style="width: 17%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="!productData.product">
                            <multiselect
                                v-model="productData.product"
                                tag-placeholder="Press enter to add"
                                placeholder="Product or Bundle"
                                label="name" track-by="id"
                                :options="allQuoteProductsAndBundles"
                                :multiple="false"
                                :taggable="true"
                                :close-on-select="true"
                                class="w-100 scalingInput"
                                @select="selectAdditionalProduct(index, productData.product, additionalIndex)"
                                group-values="item_options"
                                group-label="item_type"
                                :group-select="false"
                                :show-labels="false"
                            >
                            </multiselect>
                        </span>
                                            <span v-else>
                            <p class="font-weight-bold" v-if="productData.product.category  && productData.product.type === 'product'">{{productData.product.category.full_category_path}}</p>
                            <p :class="(productData.product.type === 'product')? 'font-weight-normal':'font-weight-bold'">{{productData.product.name}}</p>
                        </span>
                                        </div>
                                        <div style="width: 34%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="productData.product" class="w-100">
                            <p class="font-weight-normal w-100" >
                                <b-form-textarea
                                    :id="index+'-product-description'"
                                    size="sm"
                                    class="text-xs border-1 shadow-none border-grey-light"
                                    style="width: 100% !important"
                                    placeholder="Description"
                                    v-model="productData.product.description"
                                    rows="4"
                                    @input="saveQuotePricing()"
                                ></b-form-textarea>
                            </p>
                        </span>
                                        </div>
                                        <div style="width: 15%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                            <div v-if="productData.product" class="w-100">
                                                <div  class="w-100" v-if="productData.product.type === 'product' && productData.product.custom_fields.length > 0">
                                                    <div  class="w-100" v-for="(customField, fieldIndex) in productData.product.custom_fields">
                                                        <div  class="w-100 my-2" v-if="customField.type === 1">
                                                            <p class="font-weight-bold">{{customField.name}}</p>
                                                            <multiselect
                                                                v-model="customField.selected_value"
                                                                placeholder="Please Select"
                                                                label="name" track-by="id"
                                                                :options="customField.custom_field_options"
                                                                :multiple="false"
                                                                :taggable="false"
                                                                :searchable="false"
                                                                :close-on-select="true"
                                                                class="w-100"
                                                                @select="singleSelectAmountCalculateAdditional(index, fieldIndex, customField.selected_value, additionalIndex)"
                                                                @remove="(option) => singleSelectUnselectAmountCalculateAdditional(option, index, fieldIndex, additionalIndex)"
                                                                :show-labels="false"
                                                            >
                                                            </multiselect>
                                                        </div>
                                                        <div  class="w-100 my-2" v-if="customField.type === 2">
                                                            <p class="font-weight-bold">{{customField.name}}</p>
                                                            <multiselect
                                                                v-model="customField.selected_value"
                                                                placeholder="Please Select"
                                                                label="name" track-by="id"
                                                                :options="customField.custom_field_options"
                                                                :multiple="true"
                                                                :taggable="true"
                                                                :searchable="false"
                                                                :close-on-select="true"
                                                                class="w-100"
                                                                @select="multiSelectAmountCalculateAdditional(index, fieldIndex, customField.selected_value, additionalIndex)"
                                                                @remove="(option) => multiSelectUnselectAmountCalculateAdditional(option, index, fieldIndex, additionalIndex)"
                                                                :show-labels="false"
                                                            >
                                                            </multiselect>
                                                        </div>
                                                        <div  class="w-100 my-2" v-if="customField.type === 3">
                                                            <p class="font-weight-bold">{{customField.name}}</p>
                                                            <b-form-group >
                                                                <b-form-radio @change="radioButtonCalculateAdditional(index, fieldIndex, customField.selected_value, additionalIndex)" :key="'custom-radio-button-'+option.id" v-for="option in customField.custom_field_options" v-model="customField.selected_value" :name="'product-'+option.name" :value="option">{{option.name}}</b-form-radio>
                                                            </b-form-group>
                                                        </div>
                                                        <div  class="w-100 my-2" v-if="customField.type === 5">
                                                            <p><b>{{customField.name}}</b> {{customField.custom_field_options[0].name}}</p>
                                                            <b-form-textarea
                                                                :id="fieldIndex+'-product-text-field-description-'+additionalIndex"
                                                                size="sm"
                                                                class="text-xs border-1 shadow-none border-grey-light"
                                                                style="width: 100% !important"
                                                                v-model="customField.selected_value"
                                                                rows="2"
                                                                @input="saveQuotePricing()"
                                                            ></b-form-textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="productData.product" class="w-100">
                            <input v-if="productData.product.type === 'product'" @input="calculateAdditionalAmount(index, productData.quantity, productData.product, additionalIndex)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="productData.quantity">
                            <input v-else @input="calculateAdditionalBundleProducts(index, productData.quantity, productData.product, additionalIndex)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="productData.quantity">
                        </span>
                                        </div>
                                        <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                            <p class="font-weight-normal w-100" v-if="productData.product">
                                                <input @input="calculateAdditionalAmount(index, productData.product.sales_price, productData.product, additionalIndex)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="productData.product.sales_price" v-if="productData.product.type === 'product'">
                                            </p>
                                        </div>
                                        <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="productData.product" class="w-100">
                            <p class="font-weight-normal w-100" v-if="productData.amount">
                                <input @input="calculateAdditionalRateFromAmount(index, productData.amount, productData.product, additionalIndex)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="productData.amount" v-if="productData.product.type === 'product'">
                            </p>
                        </span>
                                        </div>
                                        <div style="width: 3%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                            <b-form-checkbox
                                                :id="'checkbox-'+productData.key"
                                                v-model="productData.tax"
                                                :name="'checkbox-'+productData.key"
                                                value="taxable"
                                                unchecked-value="non-taxable"
                                                v-if="productData.product && productData.product.type === 'product'"
                                                @change="calculateTotal()"
                                                class="p-0 px-2"
                                            >
                                            </b-form-checkbox>
                                            <b-form-checkbox
                                                :id="'checkbox-'+productData.key"
                                                v-model="productData.tax"
                                                :name="'checkbox-'+productData.key"
                                                value="taxable"
                                                unchecked-value="non-taxable"
                                                v-else-if="productData.product && productData.product.type === 'bundle'"
                                                @change="checkAdditionalTaxForBundle(index); calculateTotal()"
                                                class="p-0 px-2"
                                            >
                                            </b-form-checkbox>
                                        </div>
                                        <div style="width: 4%" class="px-1 py-2 d-flex align-items-center">
                                            <i @click="deleteAdditionalProduct(index, additionalIndex)" class="fa fa-trash text-danger w-full text-center text-lg cursor-pointer" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <div class="w-full d-inline-flex text-xs border-t-1 align-items-stretch" v-if="productData.product && productData.product.type === 'bundle'" v-for="(bundle, bundleIndex) in (productData.product)? productData.product.bundle_product_and_services:[]">
                                        <div style="width: 3%; color: transparent;" class="px-1 border-r-1 py-2 d-flex align-items-center">

                                        </div>
                                        <div style="width: 3%" class="px-1 border-r-1 py-2 d-flex align-items-center">

                                        </div>
                                        <div style="width: 17%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span>
                            <p class="font-weight-bold" v-if="bundle.pg_product_and_service.category">{{bundle.pg_product_and_service.category.full_category_path}}</p>
                            <p class="font-weight-normal">{{bundle.pg_product_and_service.name}}</p>
                        </span>
                                        </div>
                                        <div style="width: 34%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="bundle" class="w-100">
                            <p class="font-weight-normal w-100">
                                <b-form-textarea
                                    :id="index+'-bundle-product-description-'+bundleIndex"
                                    size="sm"
                                    class="text-xs border-1 shadow-none border-grey-light"
                                    placeholder="Description"
                                    v-model="bundle.pg_product_and_service.description"
                                    rows="4"
                                    style="width: 100% !important"
                                    @input="saveQuotePricing()"
                                ></b-form-textarea>
                            </p>
                        </span>
                                        </div>
                                        <div style="width: 15%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="bundle">
                            <div  class="w-100" v-if="bundle.pg_product_and_service.custom_fields.length > 0">
                                <div  class="w-100" v-for="(customField, fieldIndex) in bundle.pg_product_and_service.custom_fields">
                                    <div  class="w-100 my-2" v-if="customField.type === 1">
                                        <p class="font-weight-bold">{{customField.name}}</p>
                                        <multiselect
                                            v-model="customField.selected_value"
                                            placeholder="Please Select"
                                            label="name" track-by="id"
                                            :options="customField.custom_field_options"
                                            :multiple="false"
                                            :taggable="false"
                                            :searchable="false"
                                            :close-on-select="true"
                                            class="w-100"
                                            @select="bundleSingleSelectAmountCalculateAdditional(index, bundleIndex, fieldIndex, customField.selected_value, additionalIndex)"
                                            @remove="(option) => bundleSingleSelectUnselectAmountCalculateAdditional(option, bundleIndex, index, fieldIndex, additionalIndex)"
                                            :show-labels="false"
                                        >
                                        </multiselect>
                                    </div>
                                    <div  class="w-100 my-2" v-if="customField.type === 2">
                                        <p class="font-weight-bold">{{customField.name}}</p>
                                        <multiselect
                                            v-model="customField.selected_value"
                                            placeholder="Please Select"
                                            label="name" track-by="id"
                                            :options="customField.custom_field_options"
                                            :multiple="true"
                                            :taggable="true"
                                            :searchable="false"
                                            :close-on-select="true"
                                            class="w-100"
                                            @select="bundleMultiSelectAmountCalculateAdditional(index, bundleIndex, fieldIndex, customField.selected_value, additionalIndex)"
                                            @remove="(option) => bundleMultiSelectUnselectAmountCalculateAdditional(option, bundleIndex, index, fieldIndex, additionalIndex)"
                                            :show-labels="false"
                                        >
                                        </multiselect>
                                    </div>
                                    <div  class="w-100 my-2" v-if="customField.type === 3">
                                        <p class="font-weight-bold">{{customField.name}}</p>
                                        <b-form-group >
                                            <b-form-radio @change="bundleRadioButtonCalculateAdditional(index, bundleIndex, fieldIndex, customField.selected_value, additionalIndex)" :key="'bundle-custom-radio-button-'+option.id" v-for="option in customField.custom_field_options" v-model="customField.selected_value" :name="'bundle-'+option.name" :value="option">{{option.name}}</b-form-radio>
                                        </b-form-group>
                                    </div>
                                    <div  class="w-100 my-2" v-if="customField.type === 5">
                                        <p><b>{{customField.name}}</b> {{customField.custom_field_options[0].name}}</p>
                                        <b-form-textarea
                                            :id="fieldIndex+'-bundle-product-text-field-description-'+additionalIndex"
                                            size="sm"
                                            class="text-xs border-1 shadow-none border-grey-light"
                                            style="width: 100% !important"
                                            v-model="customField.selected_value"
                                            rows="2"
                                            @input="saveQuotePricing()"
                                        ></b-form-textarea>
                                    </div>
                                </div>
                            </div>
                        </span>
                                        </div>
                                        <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="bundle" class="w-100">
                            <input @input="calculateAdditionalBundleAmount(index, bundleIndex, bundle.quantity, bundle.pg_product_and_service, additionalIndex)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="bundle.quantity">
                        </span>
                                        </div>
                                        <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                            <p class="font-weight-normal w-100" v-if="bundle">
                                                <input @input="calculateAdditionalBundleAmount(index, bundleIndex, bundle.pg_product_and_service.sales_price, bundle.pg_product_and_service, additionalIndex)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="bundle.pg_product_and_service.sales_price">
                                            </p>
                                        </div>
                                        <div style="width: 7%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                        <span v-if="bundle" class="w-100">
                            <p class="font-weight-normal w-100" v-if="bundle.amount">
                                <input @input="calculateAdditionalBundleRateFromAmount(index, bundleIndex, bundle.amount, bundle.pg_product_and_service, additionalIndex)" type="number" class="form-control py-0 px-1 m-0 form-control-sm" v-model="bundle.amount">
                            </p>
                        </span>
                                        </div>
                                        <div style="width: 3%" class="px-1 border-r-1 py-2 d-flex align-items-center">
                                            <b-form-checkbox
                                                :id="'checkboxBundle-'+bundleIndex+'-'+productData.key"
                                                v-model="bundle.pg_product_and_service.sales_tax"
                                                :name="'checkboxBundle-'+bundleIndex+'-'+productData.key"
                                                value="taxable"
                                                unchecked-value="non-taxable"
                                                v-if="bundle"
                                                @change="uncheckAdditionalBundleTax(index)"
                                                class="p-0 px-2"
                                            >
                                            </b-form-checkbox>
                                        </div>
                                        <div style="width: 4%" class="px-1 py-2 d-flex align-items-center">

                                        </div>
                                    </div>
                                </div>
                            </transition-group>
                        </draggable>
                        <div class="w-full d-inline-flex text-xs border-t-1 align-items-stretch justify-content-between" v-if="additionalData.subtotal">
                            <div style="width: 90%;" class="px-1 border-r-1 py-2 d-flex align-items-center font-weight-bold text-lg justify-content-end text-right">
                                Package Total:
                            </div>
                            <div style="width: 10%;" class="px-1 py-2 d-flex align-items-center font-weight-bold text-xl ">
                                ${{additionalData.subtotal}}
                            </div>
                        </div>
                    </div>

                    <div :class="(additionalIndex !== additionalQuotePricingData.length-1)? 'w-full d-block pb-4':'w-full d-flex justify-content-between pb-4'">
                        <button class="btn btn-outline-primary  text-sm px-4 py-2 font-weight-normal" @click="addSection()" v-if="additionalIndex == additionalQuotePricingData.length-1">
                            Add Section
                        </button>
                        <button class="btn btn-outline-primary float-right text-sm px-4 py-2 font-weight-normal" @click="addRowToAdditionalSection(additionalIndex)">
                            Add Row
                        </button>
                    </div>
                </div>

                <div class="row p-0 m-0 mt-4">
                    <div class="col-6 p-0 m-0" v-if="!advanceComment">
                        <label class="font-weight-bold text-sm">Additional Comments</label>
                        <b-form-textarea
                            id="textarea-large"
                            size="lg"
                            class="text-sm w-50"
                            placeholder=""
                            v-model="additionalCommentSimple"
                            rows="4"
                            @input="saveQuotePricing()"
                        ></b-form-textarea>
                    </div>
                    <div class="col-6 p-0 m-0" v-else>
                    </div>
                    <div class="col-6 p-0 m-0">
                        <div class="row p-0 m-0 text-right">
                            <div class="col-9 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end">Subtotal</div>
                            <div class="col-3 p-0 m-0 text-right text-xl font-weight-bold">${{ (subtotal)? subtotal:0 }}</div>
                        </div>
                        <div class="row p-0 m-0 text-right mt-3" v-if="discountBeforeAfter === 'before'">
                            <div class="col-2 p-0 m-0 text-center text-sm font-weight-bold d-flex flex-col-reverse align-items-end">
                                <span  class="material-icons w-full cursor-pointer" style="font-size: 24px;color: teal;background: #d3d3d361;border-radius: 5px;padding: 3px;width: 50px;" @click="discountPosition('after')">swap_vert</span>
                            </div>
                            <div class="col-5 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end px-3">
                                <b-form-select v-model="selectedDiscountType" :options="discountTypes" size="sm" class="" @change="calculateTotal()"></b-form-select>
                            </div>
                            <div class="col-2 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end">
                                <input type="number" class="form-control border-1 text-xs" v-model="discountAmount" @input="calculateTotal()">
                            </div>
                            <div class="col-3 p-0 m-0 text-right text-xl font-weight-bold">-${{ (discountAmountPercentage)? discountAmountPercentage:0.00 }}</div>
                        </div>
                        <div class="row p-0 m-0 text-right mt-2">
                            <div class="col-9 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end">Taxable Subtotal</div>
                            <div class="col-3 p-0 m-0 text-right text-xl font-weight-bold">${{ (taxableSubtotal)? taxableSubtotal:0 }}</div>
                        </div>
                        <div class="row p-0 m-0 text-right mt-3">
                            <div class="col-3 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end">
                            </div>
                            <div class="col-5 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end px-3">
                                <b-form-select v-model="selectedSalesTax" :options="formattedSalesTax" size="sm" class="" @change="getTaxValue(selectedSalesTax)"></b-form-select>
                            </div>
                            <div class="col-1 p-0 m-0 text-right text-xl font-weight-bold">
                                {{ (taxValue)? taxValue.total_tax_rate:0 }}%
                            </div>
                            <div class="col-3 p-0 m-0 text-right text-xl font-weight-bold">${{(taxAmount)? taxAmount:0}}</div>
                        </div>
                        <div class="row p-0 m-0 text-right mt-3" v-if="discountBeforeAfter === 'after'">
                            <div class="col-2 p-0 m-0 text-center text-sm font-weight-bold d-flex flex-col-reverse align-items-end">
                                <span  class="material-icons w-full cursor-pointer" style="font-size: 24px;color: teal;background: #d3d3d361;border-radius: 5px;padding: 3px;width: 50px;" @click="discountPosition('before')">swap_vert</span>
                            </div>
                            <div class="col-5 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end px-3">
                                <b-form-select v-model="selectedDiscountType" :options="discountTypes" size="sm" class="" @change="calculateTotal()"></b-form-select>
                            </div>
                            <div class="col-2 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end">
                                <input type="number" class="form-control border-1 text-xs" v-model="discountAmount" @input="calculateTotal()">
                            </div>
                            <div class="col-3 p-0 m-0 text-right text-xl font-weight-bold">-${{ (discountAmountPercentage)? discountAmountPercentage:0.00 }}</div>
                        </div>
                        <!--                        <div class="row p-0 m-0 text-right">-->
                        <!--                            <div class="col-9 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end">Shipping</div>-->
                        <!--                            <div class="col-3 p-0 m-0 text-right text-xl font-weight-bold"><input type="number" class="form-control border-1 py-1 w-75 float-right text-right  font-weight-bold" v-model="shippingAmount" @input="calculateTotal()"></div>-->
                        <!--                        </div>-->
                        <div class="row p-0 m-0 text-right mt-2">
                            <div class="col-9 p-0 m-0 text-right text-sm font-weight-bold d-flex flex-col-reverse align-items-end">Total</div>
                            <div class="col-3 p-0 m-0 text-right text-xl font-weight-bold">${{(total)? total:0}}</div>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-12 text-center">
                        <div class="line">
                            <button class="btn btn-primary rounded-circle plus-quote-button" @click="advanceCommentChange(true)" v-if="!advanceComment">+</button>
                            <button class="btn btn-primary rounded-circle plus-quote-button" @click="advanceCommentChange(false)" v-else>-</button>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="advanceComment">
                    <div class="col-6">
                        <multiselect v-model="selectedCommentTemplates"
                                     placeholder="Select Comment Template"
                                     label="name" track-by="id"
                                     :options="quoteCommentTemplates"
                                     :multiple="false"
                                     :taggable="false"
                                     :close-on-select="true"
                                     class="w-100 mr-2"
                                     :show-labels="false"
                                     @select="selectCommentTemplateDropDown(selectedCommentTemplates)"
                        >
                            <template slot="option" slot-scope="props">
                                <div class="option-content">
                                    {{ props.option.name }}
                                    <button @click.stop="deleteCommentTemplate(props.option)" class="float-right text-danger" title="Delete"><i class="fa fa-trash text-danger" aria-hidden="true"></i></button>
                                    <button @click.stop="editCommentTemplate(props.option)" class="float-right text-warning mr-4" title="Edit Name"><i class="fa fa-pencil text-warning" aria-hidden="true"></i></button>
                                </div>
                            </template>
                        </multiselect>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-primary" @click="openCommentTemplateModal">Save New Template</button>
                        <button class="btn btn-primary" v-if="selectedCommentTemplates" @click="updateCommentTemplate">Update Template</button>
                    </div>
                    <div class="col-12 text-center mt-2">
                        <ckeditor-container placeholder="" id="comment" v-model="additionalCommentAdvance" :options="[]"
                                            @mention="addMention" mentionFrom="name" @input="saveQuotePricing()"></ckeditor-container>
                    </div>
                </div>
                <div class="row mb-5">
<!--                    <b-form-checkbox-->
<!--                        id="signature-checkbox"-->
<!--                        v-model="signature"-->
<!--                        name="checkbox-1"-->
<!--                        value="true"-->
<!--                        unchecked-value="false"-->
<!--                        @change="saveQuotePricing()"-->
<!--                    >-->
<!--                        Enable customer approval signature-->
<!--                    </b-form-checkbox>-->
                    <div class="col-4 pgQuoteProjectDiv" @click="setFocusedEditor('PGQuoteSignature')">
                        <ckeditor-container
                            editorKey="pgQuoteSignature"
                            placeholder=""
                            id="signatureData"
                            v-model="signatureData"
                            :options="[]"
                            @mention="addMention"
                            mentionFrom="name"
                            @input="saveQuotePricing()"
                            @focus="setFocusedEditor"
                            @focusout="unsetFocusedEditor"
                            ref="PGQuoteSignature"
                        ></ckeditor-container>
                    </div>
                </div>
            </div>
        </div>
        <pg-product-services-type-modal ref="PGProductServicesTypeModal"></pg-product-services-type-modal>
        <pg-product-services-modal
            ref="PGProductServicesModal"
            :typesData="typesData"
            :categoriesData="categoriesData"
            :salesTaxData="salesTaxData"
            :productServicesCustomFieldData="productServicesCustomFieldData"
            :editProductServicesData="editProductServicesData"
            :editProductServicesType="editProductServicesType" />
        <pg-bundle-modal
            ref="PGBundleModal"
            :allPGProductServices="allPGProductServices"
            :editProductServicesData="editProductServicesData"
            :editProductServicesType="editProductServicesType" />
        <!--    Saving Comment Template Modal    -->
        <div class="modal fade" id="commentTemplateSaveModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle" v-if="tempCommentTemplates">Edit Comment Template</h5>
                        <h5 class="modal-title" id="exampleModalLongTitle" v-else>Save Comment Template</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeCommentTemplateModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label>Template Name</label>
                        <input type="text" class="form-control" v-model="commentTemplateName">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeCommentTemplateModal">Close</button>
                        <button type="button" class="btn btn-primary" @click="updateCommentTemplateName" v-if="tempCommentTemplates">Update Template Name</button>
                        <button type="button" class="btn btn-primary" @click="saveCommentTemplate" v-else>Save Template</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import draggable from 'vuedraggable';
import PgProductServicesTypeModal from "./proposal-settings/quote-pricing/modal/pg-product-services-type-modal.vue";
import PgProductServicesModal from "./proposal-settings/quote-pricing/modal/pg-product-services-modal.vue";
import PgBundleModal from "./proposal-settings/quote-pricing/modal/pg-bundle-modal.vue";
import Swal from "sweetalert2";
import CkeditorContainer from "../shared/ckeditor-container.vue";
import axios from "axios";

export default {
    name: 'proposal-generator-quote-section',
    props: ['section', 'proposal', 'formattedSalesTaxesForQuote', 'quoteCommentTemplates'],
    components: {
        CkeditorContainer,
        PgBundleModal, PgProductServicesModal, PgProductServicesTypeModal, draggable, Multiselect},
    data() {
        return {
            allContacts: this.proposal.all_contacts,
            selectedContact: null,
            quoteDate: null,
            quoteExpirationDate: null,
            billingAddress: null,
            shippingAddress: null,
            additionalComment: null,
            additionalCommentSimple: null,
            additionalCommentAdvance: null,
            discountTypes: [
                {
                    value: 'discount_percentage',
                    text: 'Discount Percentage'
                },
                {
                    value: 'discount_value',
                    text: 'Discount Value'
                },
            ],
            selectedDiscountType: 'discount_percentage',
            discountAmount: null,
            allQuoteProducts: this.proposal.qp_product_services,
            quotePricingData:[],
            subtotal: null,
            discountAmountPercentage: null,
            taxableSubtotal: null,
            tax: null,
            total: null,
            taxAmount: null,
            discountBeforeAfter: 'before',
            allSalesTax: this.proposal.all_sales_taxes,
            selectedSalesTax: null,
            formattedSalesTax: this.formattedSalesTaxesForQuote,
            taxValue: null,
            shippingAmount: 0,
            allBundles: this.proposal.qp_bundles,
            allQuoteProductsAndBundles: [],
            typesData: [],
            salesTaxData: [],
            categoriesData: [],
            productServicesCustomFieldData: [],
            editProductServicesData: null,
            editProductServicesType: '',
            allPGProductServices: [],
            filter: {
                searchTimeout: null,
                dataLoading: false,
            },
            signature: false,
            sectionFetched: false,
            savingText: 'Saved',
            senderAddress: null,
            additionalQuotePricingData: [],
            sectionConfig: {
                product: {
                    original: 'Product',
                    title: 'Product',
                    show: true,
                    divWidth: 200,
                },
                description: {
                    original: 'Description',
                    title: 'Description',
                    show: true,
                    divWidth: 200,
                },
                specs: {
                    original: 'Specs',
                    title: 'Specs',
                    show: true,
                    divWidth: 200,
                },
                qty: {
                    original: 'Qty',
                    title: 'Qty',
                    show: true,
                    divWidth: 90,
                },
                rate: {
                    original: 'Rate',
                    title: 'Rate',
                    show: true,
                    divWidth: 90,
                },
                amount: {
                    original: 'Amount',
                    title: 'Amount',
                    show: true,
                    divWidth: 90,
                },
                tax: {
                    original: 'Tax',
                    title: 'Tax',
                    show: true,
                    divWidth: 90,
                }
            },
            sampleSectionConfig: {
                product: {
                    original: 'Product',
                    title: 'Product',
                    show: true,
                    divWidth: 200,
                },
                description: {
                    original: 'Description',
                    title: 'Description',
                    show: true,
                    divWidth: 200,
                },
                specs: {
                    original: 'Specs',
                    title: 'Specs',
                    show: true,
                    divWidth: 200,
                },
                qty: {
                    original: 'Qty',
                    title: 'Qty',
                    show: true,
                    divWidth: 90,
                },
                rate: {
                    original: 'Rate',
                    title: 'Rate',
                    show: true,
                    divWidth: 90,
                },
                amount: {
                    original: 'Amount',
                    title: 'Amount',
                    show: true,
                    divWidth: 90,
                },
                tax: {
                    original: 'Tax',
                    title: 'Tax',
                    show: true,
                    divWidth: 90,
                }
            },
            advanceComment: false,
            commentTemplates: this.quoteCommentTemplates,
            selectedCommentTemplates: null,
            tempCommentTemplates: null,
            commentTemplateName: '',
            selectedCommentId: null,
            projectInfo: {
                address1: null,
                address2: null,
            },
            companyInfo: {
                name: null,
                phone: null,
                address: null,
                email: null,
                salesRepName: null,
            },
            width : null,
            focusedEditorKey: null,
            templateImageData: null,
            quotePricingDataSubTotal: null,
            // salesRepData: '<p>Submitted By: {{My Name}}</p><p>Phone: {{My Number}}</p><p>Email: {{My Email}}</p><p>Date: {{Todays Date}}</p><p>Quote: {{Project ID}}</p>',
            // projectData: '<p><b>Project</b></p><p>{{Project Name}}</p><p>{{Project Address}}</p><p>{{Project City}}, {{Project State}} {{Project Zip Code}}</p>',
            // companyData: '<p><b>Prepared For</b></p><p>{{Company Name}}</p>',
            // signatureData: '<p>Approved by:</p><p>Signature: {{Contact Signature}}</p><p>Date: {{Todays Date}}</p>',
            salesRepData: null,
            projectData: null,
            companyData: null,
            signatureData: null,
            defaultFont: 'false'
        }

    },
    mounted() {
        let self = this;
        self.createOptionsForProductAndBundles();
        self.fetchQuoteSectionData();
        self.getAllPGCategoriesCompleteData();
        self.getAllPGProductServices();
        self.getFieldData();

        Bus.$on('open-pg-product-services-modal', function() {
            self.openPGProductServicesModal();
        });
        Bus.$on('open-pg-bundle-modal', function() {
            self.openPGBundleModal();
        });
        Bus.$on('get-all-pg-product-services', function() {
            self.fetchAllQuoteProductAndBundles();
        });

        document.addEventListener('click', function(event) {
            if(document.querySelector('.b-popover')){
                var isClickInside = document.querySelector('.b-popover').contains(event.target);
                if (!isClickInside) {
                    self.$refs.mainSectionConfigPopover.$emit('close');
                    if(self.$refs.sectionConfigPopover.length > 0){
                        self.$refs.sectionConfigPopover.forEach(item => {
                            item.$emit('close');
                        })
                    }
                }
            }
        });

        Bus.$on('selectCommentTemplate', function(){
           self.selectedCommentTemplate();
        });
        self.selectedCommentTemplate();

        // document.addEventListener('click', function(event) {
        //     const clickedElement = event.target;
        //     console.log(this.focusedEditorKey);
        //     if(clickedElement){
        //         if (!clickedElement.classList.contains('pgQuoteProjectDiv') && !clickedElement.classList.contains('field-tooltip')) {
        //             self.unsetFocusedEditor();
        //         }
        //     }
        // });

        Bus.$on('toolButton', data => {
            this.toolButton(data['text']);
        });

        Bus.$on('toolButtonDynamicField', data => {
            let content = { type: 'text', content: data['text'].replace(/\\n/g, "\n")};
            this.toolButtonDynamic(content.content);
        });

    },
    created() {
        this.getWidth();
    },
    methods: {
        addRow(){
            let data = {
                key: this.makeKey(5),
                product: null,
                quantity: 1,
                amount: null,
                tax: "non-taxable",
            }
            this.quotePricingData.push(data);
        },
        makeKey(length = 5){
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },
        selectProduct(index, product){
            this.$nextTick(() => {
                if(this.quotePricingData[index].product.type === 'addNewProduct'){
                    this.openPGProductServicesTypeModal();
                    this.quotePricingData[index].product = null;
                    return false;
                }
                this.quotePricingData = this.quotePricingData.map(option => JSON.parse(JSON.stringify(option)));
                // if(this.quotePricingData.length > 0){
                //     let checkCount = 0;
                //     this.quotePricingData.forEach((checkPro, checkIndex) => {
                //         if(checkPro.product.type == this.quotePricingData[index].product.type && checkPro.product.id == this.quotePricingData[index].product.id){
                //            checkCount = checkCount+1;
                //         }
                //     });
                //     if(checkCount > 1){
                //         this.quotePricingData[index].product = null;
                //         this.getToast().fire({
                //             type: 'error',
                //             title: 'Selected item is already added'
                //         });
                //         return false;
                //     }
                // }


                if(this.quotePricingData[index].product.type === 'product'){
                    this.quotePricingData[index].tax = this.quotePricingData[index].product.sales_tax;
                    if(this.quotePricingData[index].product.custom_fields.length > 0){
                        this.quotePricingData[index].product.custom_fields.forEach(item => {
                            if((item.type === 5) && item.custom_field_options.length > 0){
                                console.log(item.custom_field_options[0].price, item.custom_field_options[0]);
                                if(item.custom_field_options[0].price){
                                    this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) + parseFloat(item.custom_field_options[0].price);
                                }
                            }
                        });
                    }
                    this.calculateAmount(index, this.quotePricingData[index].quantity, this.quotePricingData[index].product);
                }else{
                    this.quotePricingData[index].product.bundle_product_and_services.forEach((item, bundleIndex) => {
                        if(item.pg_product_and_service.custom_fields.length > 0){
                            item.pg_product_and_service.custom_fields.forEach(item => {
                                if((item.type === 5) && item.custom_field_options.length > 0){
                                    if(item.custom_field_options[0].price){
                                        this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(item.custom_field_options[0].price);
                                    }
                                }
                            });
                        }
                        this.calculateBundleAmount(index, bundleIndex, item.quantity, item.pg_product_and_service);
                    });
                }

                this.quotePricingData = this.quotePricingData.map(option => JSON.parse(JSON.stringify(option)));

                this.calculateTotal();
            });
        },
        calculateAmount(index, quantity, product){
            this.quotePricingData[index].amount = this.quotePricingData[index].quantity * this.quotePricingData[index].product.sales_price;
            this.calculateTotal();
        },
        calculateRateFromAmount(index, amount, product){
            let salesPrice = 0;
            salesPrice =  amount / this.quotePricingData[index].quantity;
            this.quotePricingData[index].product.sales_price = parseFloat(salesPrice).toFixed(2);

            this.calculateTotal();
        },
        discountPosition(position){
            this.discountBeforeAfter = position;
            this.calculateTotal();
        },
        calculateTotal(fromWhere = null){
            this.$nextTick(() => {
                let subtotal = 0.00;
                let taxableSubtotal = 0.00;
                let discountAmount = 0.00;
                let subTotalAfterTax = 0.00;
                let calculatedTaxAmount = 0.00;
                let finalTotalAmount = 0.00;
                let amountOfTaxableProducts = 0.00;

                if(this.quotePricingData.length > 0){
                    this.quotePricingData.forEach(item => {
                        if(item.product){
                            if(item.product.type === 'product'){
                                if(item.amount){
                                    subtotal += parseFloat(item.amount);
                                }
                                if(item.amount && item.tax === 'taxable'){
                                    amountOfTaxableProducts += parseFloat(item.amount);
                                }
                            }else{
                                item.product.bundle_product_and_services.forEach(bundleItem => {
                                    if(bundleItem.amount){
                                        subtotal += parseFloat(bundleItem.amount);
                                    }
                                    if(bundleItem.amount && bundleItem.pg_product_and_service.sales_tax === 'taxable'){
                                        amountOfTaxableProducts += parseFloat(bundleItem.amount);
                                    }
                                })
                            }
                        }
                    });
                    this.quotePricingDataSubTotal = subtotal;
                }

                if(this.additionalQuotePricingData.length > 0){
                    this.additionalQuotePricingData.forEach(dataItem => {
                        if(dataItem.data.length > 0 && dataItem.sumToTotal == 'true'){
                            dataItem.subtotal = 0;
                            dataItem.data.forEach(item => {
                                if(item.product){
                                    if(item.product.type === 'product'){
                                        if(item.amount){
                                            subtotal += parseFloat(item.amount);
                                            dataItem.subtotal += parseFloat(item.amount);
                                        }
                                        if(item.amount && item.tax === 'taxable'){
                                            amountOfTaxableProducts += parseFloat(item.amount);
                                        }
                                    }else{
                                        item.product.bundle_product_and_services.forEach(bundleItem => {
                                            if(bundleItem.amount){
                                                subtotal += parseFloat(bundleItem.amount);
                                                dataItem.subtotal += parseFloat(bundleItem.amount);
                                            }
                                            if(bundleItem.amount && bundleItem.pg_product_and_service.sales_tax === 'taxable'){
                                                amountOfTaxableProducts += parseFloat(bundleItem.amount);
                                            }
                                        })
                                    }
                                }
                            });
                        }else if(dataItem.data.length > 0 && (dataItem.sumToTotal == 'false' || !dataItem.sumToTotal)){
                            dataItem.subtotal = 0;
                            dataItem.data.forEach(item => {
                                if(item.product){
                                    if(item.product.type === 'product'){
                                        if(item.amount){
                                            dataItem.subtotal += parseFloat(item.amount);
                                        }
                                    }else{
                                        item.product.bundle_product_and_services.forEach(bundleItem => {
                                            if(bundleItem.amount){
                                                dataItem.subtotal += parseFloat(bundleItem.amount);
                                            }
                                        })
                                    }
                                }
                            });
                        }else if(dataItem.data.length == 0){
                            dataItem.subtotal = null;
                        }
                    });
                }

                subtotal = parseFloat(subtotal).toFixed(2);
                subtotal = subtotal.toString();
                subtotal = subtotal.replace(/^0+/, '');
                this.subtotal = subtotal;
                if(this.discountBeforeAfter === 'before'){
                    if(this.selectedDiscountType === 'discount_percentage' && this.discountAmount){
                        discountAmount = (subtotal * this.discountAmount) / 100;
                        this.discountAmountPercentage = discountAmount.toFixed(2);
                        taxableSubtotal = subtotal - discountAmount;
                        taxableSubtotal = parseFloat(taxableSubtotal).toFixed(2);
                        taxableSubtotal = taxableSubtotal.toString();
                        taxableSubtotal = taxableSubtotal.replace(/^0+/, '');
                        this.taxableSubtotal = taxableSubtotal;
                    }else if(this.selectedDiscountType === 'discount_value' && this.discountAmount){
                        let disValue = this.discountAmount;
                        disValue = parseFloat(disValue).toFixed(2);
                        disValue = disValue.toString();
                        disValue = disValue.replace(/^0+/, '');

                        this.discountAmountPercentage = disValue;
                        taxableSubtotal = subtotal - this.discountAmount;
                        taxableSubtotal = parseFloat(taxableSubtotal).toFixed(2);
                        taxableSubtotal = taxableSubtotal.toString();
                        taxableSubtotal = taxableSubtotal.replace(/^0+/, '');
                        this.taxableSubtotal = taxableSubtotal;
                    }else{
                        this.discountAmount = 0;
                        this.discountAmountPercentage = parseFloat(0).toFixed(2);
                        taxableSubtotal = subtotal;
                        taxableSubtotal = parseFloat(taxableSubtotal).toFixed(2);
                        taxableSubtotal = taxableSubtotal.toString();
                        taxableSubtotal = taxableSubtotal.replace(/^0+/, '');
                        this.taxableSubtotal = taxableSubtotal;
                    }
                }else{
                    taxableSubtotal = subtotal;
                    taxableSubtotal = parseFloat(taxableSubtotal).toFixed(2);
                    taxableSubtotal = taxableSubtotal.toString();
                    taxableSubtotal = taxableSubtotal.replace(/^0+/, '');
                    this.taxableSubtotal = taxableSubtotal;
                }

                let taxA = 0;
                if(this.taxValue){
                    calculatedTaxAmount = (amountOfTaxableProducts * this.taxValue.total_tax_rate) / 100;
                    subTotalAfterTax = parseFloat(calculatedTaxAmount) + parseFloat(taxableSubtotal);
                    taxA = parseFloat(calculatedTaxAmount).toFixed(2);
                    taxA = taxA.toString();
                    taxA = taxA.replace(/^0+/, '');
                    this.taxAmount = taxA;
                }else{
                    taxA = parseFloat(taxableSubtotal).toFixed(2);
                    taxA = taxA.toString();
                    taxA = taxA.replace(/^0+/, '');
                    subTotalAfterTax = taxA;
                }

                if(this.discountBeforeAfter === 'after'){
                    if(this.selectedDiscountType === 'discount_percentage' && this.discountAmount){
                        discountAmount = (subTotalAfterTax * this.discountAmount) / 100;
                        this.discountAmountPercentage = discountAmount.toFixed(2);
                        finalTotalAmount = subTotalAfterTax - discountAmount;
                        this.total = parseFloat(finalTotalAmount) + parseFloat(this.shippingAmount);
                        this.total = this.total.toFixed(2);
                    }else if(this.selectedDiscountType === 'discount_value' && this.discountAmount){
                        let disValue = this.discountAmount;
                        disValue = parseFloat(disValue).toFixed(2);
                        disValue = disValue.toString();
                        disValue = disValue.replace(/^0+/, '');
                        this.discountAmountPercentage = disValue;
                        finalTotalAmount = subTotalAfterTax - this.discountAmount;
                        this.total = parseFloat(finalTotalAmount) + parseFloat(this.shippingAmount);
                        this.total = this.total.toFixed(2);
                    }else{
                        this.discountAmount = 0;
                        this.discountAmountPercentage = parseFloat(0).toFixed(2);
                        finalTotalAmount = subTotalAfterTax;
                        this.total = parseFloat(finalTotalAmount) + parseFloat(this.shippingAmount);
                        this.total = this.total.toFixed(2);
                    }
                }else{
                    finalTotalAmount = subTotalAfterTax;
                    this.total = parseFloat(finalTotalAmount) + parseFloat(this.shippingAmount);
                    this.total = this.total.toFixed(2);
                }

                if(!fromWhere){
                    this.saveQuotePricing();
                }
            });
        },
        getTaxValue(selectedSalesTax){
            this.taxValue = this.allSalesTax.find((item) => item.id === selectedSalesTax);
            this.calculateTotal();
        },
        createOptionsForProductAndBundles(){
            let optionArray = [];
            let productArray = [];
            let bundleArray = [];

            optionArray.push(
                {
                    item_type: 'Add New Product',
                    item_options: [
                        {
                            id: 98765432123456789,
                            type: 'addNewProduct',
                            displayName: '+Add New Product',
                            name: '+Add New Product',
                            disabled: false
                        }
                    ]
                }
            );

            if(this.allQuoteProducts.length > 0){
                this.allQuoteProducts.forEach(item => {
                    productArray.push({...item, type: 'product', displayName: item.name, disabled: false})
                });
                let product  = {
                    item_type: 'Products & Services',
                    item_options: productArray
                };
                optionArray.push(product);
            }

            if(this.allBundles.length > 0){
                this.allBundles.forEach(item => {
                    bundleArray.push({...item, type: 'bundle', displayName: item.name, disabled: false})
                });
                let bundle  = {
                    item_type: 'Bundles',
                    item_options: bundleArray
                };
                optionArray.push(bundle);
            }


            this.allQuoteProductsAndBundles = optionArray;
        },
        calculateBundleRateFromAmount(index, bundleIndex, amount, product){
            let salesPrice = 0;
            salesPrice =  amount / this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity;
            this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(salesPrice).toFixed(2);

            this.calculateTotal();
        },
        calculateBundleAmount(index, bundleIndex, quantity, product){
            this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].amount = this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity * product.sales_price;
            this.calculateTotal();
        },
        calculateBundleProducts(index, quantity, product){
            if(quantity && quantity !== 0 && quantity !=='0' && quantity !== ''){
              product.bundle_product_and_services.forEach((item, bundleIndex) => {
                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity = this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].temp_quantity * quantity;
                  this.calculateBundleAmount(index, bundleIndex, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service);
              });
              this.calculateTotal();
            }

        },
        deleteProduct(index){
            this.quotePricingData.splice(index, 1);
            this.calculateTotal();
        },
        checkTaxForBundle(index){
            this.$nextTick(() => {
                let taxValue = this.quotePricingData[index].tax;
                this.quotePricingData[index].product.bundle_product_and_services.forEach((item, bundleIndex) => {
                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_tax = taxValue;
                })

                this.calculateTotal();
            });
        },
        uncheckBundleTax(index){
            this.quotePricingData[index].tax = 'non-taxable';
            this.calculateTotal();
        },
        singleSelectAmountCalculate(index, fieldIndex, selectedValue){
            this.$nextTick(() => {
                this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) - parseFloat(this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total);
                this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total = this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.price
                if (this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.price) {
                    this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) + parseFloat(this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.price);
                }
                this.calculateAmount(index, this.quotePricingData[index].quantity, this.quotePricingData[index].product);
            });
        },
        singleSelectUnselectAmountCalculate(removedOption, index, fieldIndex){
            this.$nextTick(() => {
                if(removedOption.price){
                    this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) - parseFloat(removedOption.price);
                    this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total = 0;
                }
                this.calculateAmount(index, this.quotePricingData[index].quantity, this.quotePricingData[index].product);
            });
        },
        multiSelectAmountCalculate(index, fieldIndex, selectedValue){
            this.$nextTick(() => {
                if(this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.length > 0){
                    let totalPrice = 0;
                    totalPrice = this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total.reduce((accumulator, currentItem) => {
                        return accumulator + currentItem.price;
                    }, 0);

                    this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) - parseFloat(totalPrice);

                    this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.forEach(item => {
                        if(item.price){
                            if(!this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total.some(option => option.id === item.id)){
                                this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total.push({
                                    id: item.id,
                                    price: item.price
                                });
                            }
                        }
                    });
                    let afterTotalPrice = 0;
                    if(this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total.length > 0){
                        afterTotalPrice = this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total.reduce((accumulator, currentItem) => {
                            return accumulator + currentItem.price;
                        }, 0);
                    }

                    this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) + parseFloat(afterTotalPrice);


                }

                this.calculateAmount(index, this.quotePricingData[index].quantity, this.quotePricingData[index].product);
            });
        },
        multiSelectUnselectAmountCalculate(removedOption, index, fieldIndex){
            this.$nextTick(() => {
                if (removedOption.price) {
                    this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) - parseFloat(removedOption.price);
                    this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total = this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total.filter(item => item.id !== removedOption.id);
                }
                this.multiSelectAmountCalculate(index, fieldIndex, this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value);
            });
        },
        radioButtonCalculate(index, fieldIndex, selectedValue){
            this.$nextTick(() => {
                if (this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total.length > 0) {
                    this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) - parseFloat(this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total[0].price);
                    if (!this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total.some(option => option.id === this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.id)) {
                        this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total = [{
                            id: this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.id,
                            price: this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.price
                        }];
                        this.$nextTick(() => {
                            this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) + parseFloat(this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total[0].price);
                            this.calculateAmount(index, this.quotePricingData[index].quantity, this.quotePricingData[index].product);
                        });
                    }
                } else {
                    if (this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.price) {
                        this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total = [{
                            id: this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.id,
                            price: this.quotePricingData[index].product.custom_fields[fieldIndex].selected_value.price
                        }];
                        this.$nextTick(() => {
                            this.quotePricingData[index].product.sales_price = parseFloat(this.quotePricingData[index].product.sales_price) + parseFloat(this.quotePricingData[index].product.custom_fields[fieldIndex].temp_total[0].price);
                            this.calculateAmount(index, this.quotePricingData[index].quantity, this.quotePricingData[index].product);
                        });
                    }
                }
            });

        },
        bundleSingleSelectAmountCalculate(index, bundleIndex, fieldIndex, selectedValue){
            this.$nextTick(() => {
                this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total;
                this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price;

                if(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price){
                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price);
                }
                this.calculateBundleAmount(index, bundleIndex, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service);
            })
        },
        bundleSingleSelectUnselectAmountCalculate(removedOption, bundleIndex, index, fieldIndex){
            this.$nextTick(() => {
                if(removedOption.price){
                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - parseFloat(removedOption.price);
                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = 0;
                }
                this.calculateBundleAmount(index, bundleIndex, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service);
            });
        },
        bundleMultiSelectAmountCalculate(index, bundleIndex, fieldIndex, selectedValue){
            this.$nextTick(() => {

                if(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.length > 0){
                    let totalPrice = 0;
                    totalPrice = this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.reduce((accumulator, currentItem) => {
                        return accumulator + currentItem.price;
                    }, 0);

                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - parseFloat(totalPrice);

                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.forEach(item => {
                        if(item.price){
                            if(!this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.some(option => option.id === item.id)){
                                this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.push({
                                    id: item.id,
                                    price: item.price
                                });
                            }
                        }
                    });
                    let afterTotalPrice = 0;
                    if(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.length > 0){
                        afterTotalPrice = this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.reduce((accumulator, currentItem) => {
                            return accumulator + currentItem.price;
                        }, 0);
                    }

                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(afterTotalPrice);


                }

                this.calculateBundleAmount(index, bundleIndex, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service);
            });
        },
        bundleMultiSelectUnselectAmountCalculate(removedOption, bundleIndex, index, fieldIndex){
            this.$nextTick(() => {
                if(removedOption.price){
                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - parseFloat(removedOption.price);
                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.filter(item => item.id !== removedOption.id);
                }
                this.bundleMultiSelectAmountCalculate(index, bundleIndex, fieldIndex, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value);
            });
        },
        bundleRadioButtonCalculate(index, bundleIndex, fieldIndex, selectedValue){
            this.$nextTick(() => {

                if(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.length > 0){
                    this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total[0].price);
                    if(!this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.some(option => option.id === this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.id)){
                        this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = [{
                            id: this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.id,
                            price: this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price
                        }];
                        this.$nextTick(() => {
                            this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total[0].price);
                            this.calculateBundleAmount(index, bundleIndex, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service);
                        });
                    }
                }else{
                    if(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price){
                        this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = [{
                            id: this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.id,
                            price: this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price
                        }];
                        this.$nextTick(() => {
                            this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total[0].price);
                            this.calculateBundleAmount(index, bundleIndex, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].quantity, this.quotePricingData[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service);
                        });
                    }
                }
            });
        },
        selectContactAddress(selectedContact){
            this.$nextTick(() => {
                if(this.selectedContact.address){
                    this.billingAddress = this.selectedContact.address;
                    this.shippingAddress = this.selectedContact.address;
                }else{
                    this.billingAddress = null;
                    this.shippingAddress = null;
                }
            });
        },
        removeContactAddress(removedOption){
            this.billingAddress = null;
            this.shippingAddress = null;
        },
        saveQuotePricing(autoSave = null){
            this.$nextTick(() => {
                if(this.sectionFetched){
                    let data = {
                        selectedContact: this.selectedContact,
                        quoteDate: this.quoteDate,
                        quoteExpirationDate: this.quoteExpirationDate,
                        billingAddress: this.billingAddress,
                        shippingAddress: this.shippingAddress,
                        additionalComment: (this.advanceComment)? this.additionalCommentAdvance:this.additionalCommentSimple,
                        additionalCommentSimple: (this.additionalCommentSimple)? this.additionalCommentSimple:null,
                        additionalCommentAdvance: (this.additionalCommentAdvance)? this.additionalCommentAdvance:null,
                        selectedDiscountType: this.selectedDiscountType,
                        discountAmount: this.discountAmount,
                        quotePricingData: this.quotePricingData,
                        subtotal: this.subtotal,
                        discountAmountPercentage: this.discountAmountPercentage,
                        taxableSubtotal: this.taxableSubtotal,
                        tax: this.tax,
                        total: this.total,
                        taxAmount: this.taxAmount,
                        discountBeforeAfter: this.discountBeforeAfter,
                        selectedSalesTax: this.selectedSalesTax,
                        taxValue: this.taxValue,
                        shippingAmount: this.shippingAmount,
                        proposalCustomSectionId: this.section.id,
                        proposalId: this.proposal.id,
                        signature: this.signature,
                        senderAddress: this.senderAddress,
                        additionalQuotePricingData: this.additionalQuotePricingData,
                        sectionConfig: this.sectionConfig,
                        advanceComment: (this.advanceComment)? 1:0,
                        selectedCommentId: this.selectedCommentId,
                        projectInfo: this.projectInfo,
                        companyInfo: this.companyInfo,
                        salesRepData: this.salesRepData,
                        companyData: this.companyData,
                        projectData: this.projectData,
                        signatureData: this.signatureData,
                        quotePricingDataSubTotal: this.quotePricingDataSubTotal,
                        defaultFont: this.defaultFont,
                    }
                    this.savingText = 'Saving...';
                    axios.post(route('proposal.quote-section.save-section'), data).then(response => {
                        if(autoSave){
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                        }
                        this.savingText = 'Saved';
                        Bus.$emit('changeReviewButtonPrizm', true);
                    });
                }
            });
        },
        fetchQuoteSectionData(){
            axios.post(route('proposal.quote-section.get-section-data'), {sectionId: this.section.id, projectId: this.proposal.project_id}).then(response => {
               if(response.data.quoteSection){
                   this.formatSectionData(response.data.quoteSection, response.data.projectInfo, response.data.companyInfo);
                   this.templateImageData = response.data.templateImageData;
               }else{
                   this.sectionFetched = true;
               }
            });
        },
        formatSectionData(data, projectInfoDB, companyInfoDB){

            this.selectedContact = (data.company_contact_id)? this.allContacts.find(obj => obj.id === data.company_contact_id):(data.project_contact_id)? this.allContacts.find(obj => obj.id === data.project_contact_id):null;
            this.quoteDate = (data.quote_date !== null)? new Date(data.quote_date).toISOString():null;
            this.quoteExpirationDate = (data.quote_expiration_date)? new Date(data.quote_expiration_date).toISOString():null;
            this.billingAddress = (data.billing_address)? data.billing_address:null;
            this.shippingAddress = (data.shipping_address)? data.shipping_address:null;
            this.additionalCommentAdvance = (data.additional_comment_advance)? data.additional_comment_advance:(data.advance_comment == 1 && data.additional_comment)? data.additional_comment: null;
            this.additionalCommentSimple = (data.additional_comment_simple)? data.additional_comment_simple:(data.advance_comment == 0 && data.additional_comment)? data.additional_comment: null;
            this.selectedDiscountType = (data.discount_type)? data.discount_type:null;
            this.discountAmount = (data.discount_amount)? data.discount_amount:null;
            this.quotePricingData = (data.quote_pricing_data)? JSON.parse(data.quote_pricing_data):[];
            this.subtotal = (data.subtotal)? data.subtotal:null;
            this.discountAmountPercentage = (data.discount_amount_percentage)? data.discount_amount_percentage:null;
            this.taxableSubtotal = (data.taxable_subtotal)? data.taxable_subtotal:null;
            this.total = (data.total)? data.total:null;
            this.taxAmount = (data.tax_amount)? data.tax_amount:null;
            this.discountBeforeAfter = (data.discount_before_after)? data.discount_before_after:'before';
            this.selectedSalesTax = (data.sales_tax_id)? data.sales_tax_id:null;
            this.taxValue = (data.sales_tax_id)? this.allSalesTax.find(obj => obj.id === data.sales_tax_id):null;
            this.shippingAmount = (data.shipping_amount)? data.shipping_amount:0;
            this.signature = (data.signature == 1)? true:false;
            this.senderAddress = data.sender_address;
            this.additionalQuotePricingData = (data.additional_quote_pricing_data)? JSON.parse(data.additional_quote_pricing_data):[];
            this.sectionConfig = (data.section_config)? JSON.parse(data.section_config): this.sampleSectionConfig;
            this.addDivWidthToSectionConfig();
            this.advanceComment = (data.advance_comment == 1)? true: false;
            this.selectedCommentId = (data.comment_template_id)? data.comment_template_id: null;
            this.salesRepData = (data.sales_rep_data)? data.sales_rep_data: null;
            this.companyData = (data.company_data)? data.company_data: null;
            this.projectData = (data.project_data)? data.project_data: null;
            this.signatureData = (data.signature_data)? data.signature_data: null;
            this.quotePricingDataSubTotal = (data.default_quote_subtotal)? data.default_quote_subtotal: null;
            this.defaultFont= (data.default_font == 1)? 'true': 'false';

            if(data.project_info){
                let projectInfoData = JSON.parse(data.project_info);
                this.projectInfo.address1 = projectInfoData.address1;
                this.projectInfo.address2 = projectInfoData.address2;
            }else{
                this.projectInfo.address1 = projectInfoDB;
            }

            if(data.company_info){
                let companyInfoData = JSON.parse(data.company_info);
                this.companyInfo.name = companyInfoData.name;
                this.companyInfo.salesRepName = companyInfoData.salesRepName;
                this.companyInfo.phone = companyInfoData.phone;
                this.companyInfo.email = companyInfoData.email;
                this.companyInfo.address = companyInfoData.address;
            }else if(companyInfoDB){
                let companyInfoDBData = JSON.parse(companyInfoDB);
                this.companyInfo.name = companyInfoDBData.name;
                this.companyInfo.salesRepName = null;
                this.companyInfo.phone = companyInfoDBData.phone;
                this.companyInfo.email = companyInfoDBData.email;
                this.companyInfo.address = companyInfoDBData.address;
            }
            this.sectionFetched = true;
            this.checkAndAddKey(this.additionalQuotePricingData, 'sumToTotal', 'true');
            this.calculateTotal('formating');
            this.selectedCommentTemplate();
        },
        openPGProductServicesTypeModal() {
            this.$refs.PGProductServicesTypeModal.open();
        },
        openPGProductServicesModal() {
            this.$refs.PGProductServicesModal.open();
        },
        openPGBundleModal() {
            this.$refs.PGBundleModal.open();
        },
        getAllPGCategoriesCompleteData(filter = null) {
            let self = this;
            self.filter.dataLoading = true;
            axios.get(route('api.proposal-settings.category.get-categories-complete-data', {filter})).then(response => {
                this.allPGCategories = response.data.data;
                self.filter.dataLoading = false;
            });
        },
        getAllPGProductServices(filter = null) {
            let self = this;
            self.filter.dataLoading = true;
            axios.get(route('api.proposal-settings.product-services.index'), {filter}).then(response => {
                this.allPGProductServices = response.data.data;
                self.filter.dataLoading = false;
            });
        },
        getFieldData() {
            let self = this;
            axios.get(route('api.proposal-settings.product-services.get-field-data')).then((response) => {
                self.typesData = response.data.types;
                self.salesTaxData = response.data.salesTax;
                self.categoriesData = response.data.categories;
                self.productServicesCustomFieldData = response.data.productServicesCustomField;
            });
        },
        fetchAllQuoteProductAndBundles(){
            axios.post(route('proposal.quote-section.get-all-product-and-bundles')).then(response => {
                this.allQuoteProducts = response.data.productAndServices;
                this.allBundles = response.data.bundles;
                this.createOptionsForProductAndBundles();
            });
        },
        addSection(){
            let data = {
                key: this.makeKey(5),
                sectionTitle: 'Additional Section',
                sumToTotal: false,
                product: {
                    original: 'Product',
                    title: 'Product',
                    show: true,
                    divWidth: 200,
                },
                description: {
                    original: 'Description',
                    title: 'Description',
                    show: true,
                    divWidth: 200,
                },
                specs: {
                    original: 'Specs',
                    title: 'Specs',
                    show: true,
                    divWidth: 200,
                },
                qty: {
                    original: 'Qty',
                    title: 'Qty',
                    show: true,
                    divWidth: 90,
                },
                rate: {
                    original: 'Rate',
                    title: 'Rate',
                    show: true,
                    divWidth: 90,
                },
                amount: {
                    original: 'Amount',
                    title: 'Amount',
                    show: true,
                    divWidth: 90,
                },
                tax: {
                    original: 'Tax',
                    title: 'Tax',
                    show: true,
                    divWidth: 90,
                },
                data: [
                    {
                        key: this.makeKey(5),
                        product: null,
                        quantity: 1,
                        amount: null,
                        tax: "non-taxable",
                    }
                ],
                subtotal: 0,
            }
            this.additionalQuotePricingData.push(data);
            this.additionalQuotePricingData = this.additionalQuotePricingData.map(option => JSON.parse(JSON.stringify(option)));
        },
        addRowToAdditionalSection(index){
            let data = {
                key: this.makeKey(5),
                product: null,
                quantity: 1,
                amount: null,
                tax: "non-taxable",
            };
            this.additionalQuotePricingData[index].data.push(data);
            this.additionalQuotePricingData = this.additionalQuotePricingData.map(option => JSON.parse(JSON.stringify(option)));
        },
        selectAdditionalProduct(index, product, additionalIndex){
            this.$nextTick(() => {
                if(this.additionalQuotePricingData[additionalIndex].data[index].product.type === 'addNewProduct'){
                    this.openPGProductServicesTypeModal();
                    this.additionalQuotePricingData[additionalIndex].data[index].product = null;
                    return false;
                }
                this.additionalQuotePricingData = this.additionalQuotePricingData.map(option => JSON.parse(JSON.stringify(option)));
                if(this.additionalQuotePricingData[additionalIndex].data[index].product.type === 'product'){
                    this.additionalQuotePricingData[additionalIndex].data[index].tax = this.additionalQuotePricingData[additionalIndex].data[index].product.sales_tax;
                    if(this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields.length > 0){
                        this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields.forEach(item => {
                            if((item.type === 5) && item.custom_field_options.length > 0){
                                if(item.custom_field_options[0].price){
                                    this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) + parseFloat(item.custom_field_options[0].price);
                                }
                            }
                        });
                    }
                    this.calculateAdditionalAmount(index, this.additionalQuotePricingData[additionalIndex].data[index].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product, additionalIndex);
                }else{
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services.forEach((item, bundleIndex) => {
                        if(item.pg_product_and_service.custom_fields.length > 0){
                            item.pg_product_and_service.custom_fields.forEach(item => {
                                if((item.type === 5) && item.custom_field_options.length > 0){
                                    if(item.custom_field_options[0].price){
                                        this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(item.custom_field_options[0].price);
                                    }
                                }
                            });
                        }
                        this.calculateAdditionalBundleAmount(index, bundleIndex, item.quantity, item.pg_product_and_service, additionalIndex);
                    });
                }

                this.additionalQuotePricingData = this.additionalQuotePricingData.map(option => JSON.parse(JSON.stringify(option)));
                this.calculateTotal();
            });
        },
        calculateAdditionalAmount(index, quantity, product, additionalIndex){
            this.additionalQuotePricingData[additionalIndex].data[index].amount = this.additionalQuotePricingData[additionalIndex].data[index].quantity * this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price;
            this.calculateTotal();
        },
        calculateAdditionalBundleAmount(index, bundleIndex, quantity, product, additionalIndex){
            this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].amount = this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity * product.sales_price;
            this.calculateTotal();
        },
        deleteAdditionalProduct(index, additionalIndex){
            this.additionalQuotePricingData[additionalIndex].data.splice(index, 1);
            this.calculateTotal();
        },
        calculateAdditionalBundleProducts(index, quantity, product, additionalIndex){
            if(quantity && quantity !== 0 && quantity !=='0' && quantity !== ''){
                product.bundle_product_and_services.forEach((item, bundleIndex) => {
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity = this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].temp_quantity * quantity;
                    this.calculateAdditionalBundleAmount(index, bundleIndex, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service, additionalIndex);
                });
            }

        },
        calculateAdditionalRateFromAmount(index, amount, product, additionalIndex){
            let salesPrice = 0;
            salesPrice =  amount / this.additionalQuotePricingData[additionalIndex].data[index].quantity;
            this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(salesPrice).toFixed(2);
            this.calculateTotal();
        },
        calculateAdditionalBundleRateFromAmount(index, bundleIndex, amount, product, additionalIndex){
            let salesPrice = 0;
            salesPrice =  amount / this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity;
            this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(salesPrice).toFixed(2);
            this.calculateTotal();
        },
        checkAdditionalTaxForBundle(index, additionalIndex){
            this.$nextTick(() => {
                let taxValue = this.additionalQuotePricingData[additionalIndex].data[index].tax;
                this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services.forEach((item, bundleIndex) => {
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_tax = taxValue;
                })
            });
            this.calculateTotal();
        },
        uncheckAdditionalBundleTax(index, additionalIndex){
            this.additionalQuotePricingData[additionalIndex].data[index].tax = 'non-taxable';
            this.calculateTotal();
        },
        singleSelectAmountCalculateAdditional(index, fieldIndex, selectedValue, additionalIndex){
            this.$nextTick(() => {
                this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) - parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total);
                this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total = this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.price
                if (this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.price) {
                    this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) + parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.price);
                }
                this.calculateAdditionalAmount(index, this.additionalQuotePricingData[additionalIndex].data[index].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product, additionalIndex);
            });
        },
        singleSelectUnselectAmountCalculateAdditional(removedOption, index, fieldIndex, additionalIndex){
            this.$nextTick(() => {
                if(removedOption.price){
                    this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) - parseFloat(removedOption.price);
                    this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total = 0;
                }
                this.calculateAdditionalAmount(index, this.additionalQuotePricingData[additionalIndex].data[index].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product, additionalIndex);
            });
        },
        multiSelectAmountCalculateAdditional(index, fieldIndex, selectedValue, additionalIndex){
            this.$nextTick(() => {
                if(this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.length > 0){
                    let totalPrice = 0;
                    totalPrice = this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total.reduce((accumulator, currentItem) => {
                        return accumulator + currentItem.price;
                    }, 0);

                    this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) - parseFloat(totalPrice);

                    this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.forEach(item => {
                        if(item.price){
                            if(!this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total.some(option => option.id === item.id)){
                                this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total.push({
                                    id: item.id,
                                    price: item.price
                                });
                            }
                        }
                    });
                    let afterTotalPrice = 0;
                    if(this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total.length > 0){
                        afterTotalPrice = this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total.reduce((accumulator, currentItem) => {
                            return accumulator + currentItem.price;
                        }, 0);
                    }

                    this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) + parseFloat(afterTotalPrice);


                }

                this.calculateAdditionalAmount(index, this.additionalQuotePricingData[additionalIndex].data[index].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product, additionalIndex);
            });
        },
        multiSelectUnselectAmountCalculateAdditional(removedOption, index, fieldIndex, additionalIndex){
            this.$nextTick(() => {
                if (removedOption.price) {
                    this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) - parseFloat(removedOption.price);
                    this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total = this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total.filter(item => item.id !== removedOption.id);
                }
                this.multiSelectAmountCalculateAdditional(index, fieldIndex, this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value, additionalIndex);
            });
        },
        radioButtonCalculateAdditional(index, fieldIndex, selectedValue, additionalIndex){
            this.$nextTick(() => {
                if (this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total.length > 0) {
                    this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) - parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total[0].price);
                    if (!this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total.some(option => option.id === this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.id)) {
                        this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total = [{
                            id: this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.id,
                            price: this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.price
                        }];
                        this.$nextTick(() => {
                            this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) + parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total[0].price);
                            this.calculateAdditionalAmount(index, this.additionalQuotePricingData[additionalIndex].data[index].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product, additionalIndex);
                        });
                    }
                } else {
                    if (this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.price) {
                        this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total = [{
                            id: this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.id,
                            price: this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].selected_value.price
                        }];
                        this.$nextTick(() => {
                            this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.sales_price) + parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.custom_fields[fieldIndex].temp_total[0].price);
                            this.calculateAdditionalAmount(index, this.additionalQuotePricingData[additionalIndex].data[index].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product, additionalIndex);
                        });
                    }
                }
            });

        },
        bundleSingleSelectAmountCalculateAdditional(index, bundleIndex, fieldIndex, selectedValue, additionalIndex){
            this.$nextTick(() => {
                this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total;
                this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price;

                if(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price){
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price);
                }
                this.calculateAdditionalBundleAmount(index, bundleIndex, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service, additionalIndex);
            })
        },
        bundleSingleSelectUnselectAmountCalculateAdditional(removedOption, bundleIndex, index, fieldIndex, additionalIndex){
            this.$nextTick(() => {
                if(removedOption.price){
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - parseFloat(removedOption.price);
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = 0;
                }
                this.calculateAdditionalBundleAmount(index, bundleIndex, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service, additionalIndex);
            });
        },
        bundleMultiSelectAmountCalculateAdditional(index, bundleIndex, fieldIndex, selectedValue, additionalIndex){
            this.$nextTick(() => {

                if(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.length > 0){
                    let totalPrice = 0;
                    totalPrice = this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.reduce((accumulator, currentItem) => {
                        return accumulator + currentItem.price;
                    }, 0);

                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - parseFloat(totalPrice);

                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.forEach(item => {
                        if(item.price){
                            if(!this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.some(option => option.id === item.id)){
                                this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.push({
                                    id: item.id,
                                    price: item.price
                                });
                            }
                        }
                    });
                    let afterTotalPrice = 0;
                    if(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.length > 0){
                        afterTotalPrice = this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.reduce((accumulator, currentItem) => {
                            return accumulator + currentItem.price;
                        }, 0);
                    }

                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(afterTotalPrice);


                }

                this.calculateAdditionalBundleAmount(index, bundleIndex, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service, additionalIndex);
            });
        },
        bundleMultiSelectUnselectAmountCalculateAdditional(removedOption, bundleIndex, index, fieldIndex, additionalIndex){
            this.$nextTick(() => {
                if(removedOption.price){
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - parseFloat(removedOption.price);
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.filter(item => item.id !== removedOption.id);
                }
                this.bundleMultiSelectAmountCalculateAdditional(index, bundleIndex, fieldIndex, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value, additionalIndex);
            });
        },
        bundleRadioButtonCalculateAdditional(index, bundleIndex, fieldIndex, selectedValue, additionalIndex){
            this.$nextTick(() => {

                if(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.length > 0){
                    this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) - parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total[0].price);
                    if(!this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total.some(option => option.id === this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.id)){
                        this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = [{
                            id: this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.id,
                            price: this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price
                        }];
                        this.$nextTick(() => {
                            this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total[0].price);
                            this.calculateAdditionalBundleAmount(index, bundleIndex, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service, additionalIndex);
                        });
                    }
                }else{
                    if(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price){
                        this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total = [{
                            id: this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.id,
                            price: this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].selected_value.price
                        }];
                        this.$nextTick(() => {
                            this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price = parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.sales_price) + parseFloat(this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service.custom_fields[fieldIndex].temp_total[0].price);
                            this.calculateAdditionalBundleAmount(index, bundleIndex, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].quantity, this.additionalQuotePricingData[additionalIndex].data[index].product.bundle_product_and_services[bundleIndex].pg_product_and_service, additionalIndex);
                        });
                    }
                }
            });
        },
        removeSection(additionalIndex){
            Swal.fire({
                title: 'Delete Section',
                text: "Do you want to delete "+this.additionalQuotePricingData[additionalIndex].sectionTitle,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'Delete!'
            }).then((result) => {
                if (result.value) {
                    this.additionalQuotePricingData.splice(additionalIndex, 1);
                    this.calculateTotal();
                }else{
                    return false;
                }
            });
        },
        checkAndAddKey(additionalArray, key, defaultValue) {
            additionalArray.forEach(item => {
                if (!(key in item)) {
                    item[key] = defaultValue;
                }
            });
        },
        advanceCommentChange(state){
            this.advanceComment = state;
            this.saveQuotePricing();
        },
        addMention(){

        },
        openCommentTemplateModal(){
            if(this.additionalCommentAdvance){
                this.commentTemplateName = '';
                this.tempCommentTemplates = null;
                $('#commentTemplateSaveModal').modal('show');
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter some text in comment'
                });
                return false;
            }

        },
        closeCommentTemplateModal(){
            this.commentTemplateName = '';
            this.tempCommentTemplates = null;
            $('#commentTemplateSaveModal').modal('hide');
        },
        saveCommentTemplate(){
            if(this.commentTemplateName.trim()){
                axios.post(route('proposal.quote-section.save-quote-comment-template'), {name: this.commentTemplateName, comment: this.additionalCommentAdvance, sectionId: this.section.id}).then(response => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    Bus.$emit('fetchAllQuoteCommentTemplates', true);
                    this.closeCommentTemplateModal();
                    this.fetchQuoteSectionData();
                });
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter template name'
                });
                return false;
            }
        },
        deleteCommentTemplate(option){
            Swal.fire({
                title: 'Delete Comment Template',
                text: "Do you want to delete "+option.name,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'Delete!'
            }).then((result) => {
                if (result.value) {
                    axios.post(route('proposal.quote-section.delete-quote-comment-template'), {templateId: option.id}).then(response => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        Bus.$emit('fetchAllQuoteCommentTemplates', true);
                    });
                }else{
                    return false;
                }
            });
        },
        selectCommentTemplateDropDown(commentTemplate){
            console.log(commentTemplate, this.selectedCommentTemplates);
            this.$nextTick(() => {
            this.additionalCommentAdvance = (this.selectedCommentTemplates)? this.selectedCommentTemplates.comment:'';
            this.selectedCommentId = (this.selectedCommentTemplates)? this.selectedCommentTemplates.id:null;
               this.saveQuotePricing();
            });
        },
        editCommentTemplate(commentTemplate){
            this.tempCommentTemplates = commentTemplate;
            this.commentTemplateName = commentTemplate.name;
            $('#commentTemplateSaveModal').modal('show');
        },
        updateCommentTemplateName(){
            if(this.commentTemplateName.trim()){
                axios.post(route('proposal.quote-section.update-quote-comment-template-name'), {templateId: this.tempCommentTemplates.id, name: this.commentTemplateName}).then(response => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    Bus.$emit('fetchAllQuoteCommentTemplates', true);
                    this.closeCommentTemplateModal();
                });
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter template name'
                });
                return false;
            }
        },
        updateCommentTemplate(){
            axios.post(route('proposal.quote-section.update-quote-comment-template'), {templateId: this.selectedCommentTemplates.id, comment: this.additionalCommentAdvance}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                Bus.$emit('fetchAllQuoteCommentTemplates', true);
            });
        },
        selectedCommentTemplate(){
            if(this.quoteCommentTemplates.length > 0){
                this.selectedCommentTemplates = this.quoteCommentTemplates.find(template => template.id == this.selectedCommentId);
            }
        },
        addDivWidthToSectionConfig(){
            const keys = Object.keys(this.sectionConfig);
            keys.forEach((key, index) => {
                if (!this.sectionConfig[key].hasOwnProperty('divWidth')) {
                    if (key === 'product' || key === 'description' || key === 'specs') {
                        this.$set(this.sectionConfig[key], 'divWidth', 200);
                    } else {
                        this.$set(this.sectionConfig[key], 'divWidth', 90);
                    }
                }
            });
        },
        getWidth() {
            let self = this;

            $(window).click((event)=>{
                let divId = $(event.target).attr('id');
                if(divId){
                    const hasHyphen = divId.includes('-');
                    const matchArray = ['product', 'description', 'specs', 'amount', 'rate', 'tax', 'qty'];
                    if(hasHyphen){
                        const parts = divId.split('-');
                        const textAfterHyphen = parts.slice(1).join('-');
                        const isExactMatch = matchArray.includes(parts[0]);
                        if(isExactMatch){
                            console.log(document.getElementById(divId));
                            let divEle = document.getElementById(divId);
                            let divWidth = divEle.style.width;
                            let keyToAdd = "divWidth";
                            console.log(textAfterHyphen, divId);
                            if (!(keyToAdd in this.additionalQuotePricingData[textAfterHyphen][parts[0]])) {
                                this.additionalQuotePricingData[textAfterHyphen][parts[0]][keyToAdd] = parseFloat(divWidth);
                            }else{
                                this.additionalQuotePricingData[textAfterHyphen][parts[0]].divWidth = parseFloat(divWidth);
                            }
                            this.saveQuotePricing();
                        }
                    }else{
                        const isExactMatch = matchArray.includes(divId);
                        if(isExactMatch){
                            let divEle = document.getElementById(divId);
                            let divWidth = divEle.style.width;
                            let keyToAdd = "divWidth";
                            if (!(keyToAdd in this.sectionConfig[divId])) {
                                this.sectionConfig[divId][keyToAdd] = parseFloat(divWidth);
                            }else{
                                this.sectionConfig[divId].divWidth = parseFloat(divWidth);
                            }
                            this.saveQuotePricing();
                        }
                    }
                }
            });
        },
        setFocusedEditor(editorKey) {
            this.focusedEditorKey = editorKey;
        },
        unsetFocusedEditor() {
            this.focusedEditorKey = null;
        },
        toolButton(data){
            this.$refs[this.focusedEditorKey].addField('{{'+data+'}}');
        },
        toolButtonDynamic(data){
            this.$refs[this.focusedEditorKey].addField(data);
        },
    },
}
</script>
<style scoped>
.scalingInput {
    transform: scale(.75);
    -webkit-transform: scale(.75);
}
.customFlexBasis {
    flex-basis: calc(3% - 0px);
}
.custom-title-height {
    height: 15px;
}

.line {
    position: relative;
    height: 50px;  /* Adjust the height of the line as needed */
}

.line::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    border-top: 0.5px solid silver;
    transform: translateY(-50%);
}

.btn.plus-quote-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    font-size: 20px;
    line-height: 5px;
    border: 1px solid white;
    padding: 5px;
    background: #38b2b0;
    color: white;
}
.w-50{
    width: 50% !important;
}


th.column-header-resize {
    padding: 0;
    margin: 0px;
}

th.column-header-resize div.column-resize {
    resize: horizontal;
    overflow: auto;
    min-width: 90%;
    margin: 0px;
    padding: 0px;
    display: block;
    border: 0;
    cursor: nwse-resize;
}

.quote-section-table-class th,
.quote-section-table-class td {
    padding: 5px;
}

.quote-section-table-class thead {
    background: rgb(234, 255, 254);
}

.quote-section-table-class {
    font-size: .75rem;
}

.follow-up-scrollbar::-webkit-scrollbar-track
{

    border-radius: 10px;
    background-color: #F5F5F5;
}

.follow-up-scrollbar::-webkit-scrollbar
{
    width: 12px;
    background-color: #F5F5F5;
    height: 8px;
    margin-top: 10px;
}

.follow-up-scrollbar::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    background-color: #38b2b0;
}

.add-custom-min-height {
    min-height: 200px;
}


</style>
<style>
.multiselect__input::placeholder {
    visibility: hidden;
}
.additionalPopOverClass .popover-body {
    overflow: hidden !important;
    height: fit-content !important;
}
</style>
